var productImgArray = [];
var thumbImgArray = [];
var $buttonGroup = $('.hero__button-group.jsc-scroll-x-slider');
var $section = $buttonGroup.closest('section');
var originalTop = null;

$(function(){
  initRelatedProductSlider();
  cartJSEvent();
  initExtraPackagingCollectionQuickAdd();
    masterGWP();

    // if (window.location.pathname !== '/cart') {
     renderCartUpsell();
    // }
    sectionTextColumnGridHeight();
    gridHeight();
    tabColGridHeight();
    sectionColGridHeight();
    sectionColListGridHeight();
    cartFreeShipping();
    gwp_progressbar();
    tier_gwp_progressbar();
    checkGwpOptStatus();
    checkTierGwpOptStatus();
    anchorToMyReward();
    accountPageAnchor();
    initProductGridImageSlider();
    openLinkNewTab();
    updateArrowPos();
    enableSlideshowAnimation();
    initTagPageSlider();
    checkStoreCredit();
    removeLeftoverMessageCard();
    toggleGwpProgressBar();
    toggleTierGwpProgressBar();

    if (window.location.hash === '#jscAnchrFdStore') {
      expandFindInStore();
    }
    rewardAnchorPos();
    anchorToRewardSection();

    if ($(window).width() < 481){
      getAllProductImage();
      getAllThumbImage();
    }
    onLoadUpdateVariantImg();
    updatePWP();

    initSplideAutoScroll();

  $(window).on('resize', function() {
    sectionTextColumnGridHeight();
  });
  if (location.href.includes('/products')) {
    controlVariantOption();
  }
  // Safety check: Prevent checkout when GWP operations are in progress
  // This is a last line of defense against race conditions
  // Blocks checkout for ALL GWP operations (add, update, remove) to ensure:
  // 1. Customers don't checkout with unqualified GWP (remove case)
  // 2. Customers get their entitled GWP before checkout (add case)
  // Applies to: Tier GWP, Normal GWP, and Qty GWP
  $(document).on('submit', 'form.cart__form, form[action*="/cart"], form[action*="/checkout"]', function(e) {
    // Only block if the submit button is a checkout button (not update cart, etc.)
    var $submitBtn = $(document.activeElement);
    var isCheckoutSubmit = $submitBtn.attr('name') === 'checkout';
    
    if (!isCheckoutSubmit) {
      return true; // Allow non-checkout form submissions
    }
    
    // Check if any GWP operations are in progress
    if (window.tierGwpOperationInProgress || window.gwpOperationInProgress) {
      e.preventDefault();
      console.log('Checkout blocked: GWP operations in progress');
      return false;
    }
    
    // Check for ALL pending GWP operations across all GWP types
    // Tier GWP
    var hasTierGwpAddOps = $('input[name="jsc-tier-gwp"][jsc-add-gwp]').length > 0;
    var hasTierGwpUpdateOps = $('input[name="jsc-tier-gwp"][jsc-update-gwp]').length > 0;
    var hasTierGwpRemoveOps = $('input[name="jsc-tier-gwp"][jsc-remove-gwp]').length > 0;
    var hasTierGwpOps = hasTierGwpAddOps || hasTierGwpUpdateOps || hasTierGwpRemoveOps;
    
    // Normal GWP
    var hasNormalGwpAddOps = $('.jsc-add-cart-gift').length > 0;
    var hasNormalGwpUpdateOps = $('.jsc-updateqty-cart-gift').length > 0;
    var hasNormalGwpRemoveOps = $('.jsc-remove-cart-gift').length > 0;
    var hasNormalGwpSwapOps = $('.jsc-remove-cart-gift-swap').length > 0 && $('.jsc-add-cart-gift-swap').length > 0;
    var hasNormalGwpOps = hasNormalGwpAddOps || hasNormalGwpUpdateOps || hasNormalGwpRemoveOps || hasNormalGwpSwapOps;
    
    // Qty GWP
    var hasQtyGwpAddOps = $('.jsc-add-gwp:not([name="jsc-tier-gwp"])').length > 0;
    var hasQtyGwpUpdateOps = $('.jsc-update-gwp:not([name="jsc-tier-gwp"])').length > 0;
    var hasQtyGwpRemoveOps = $('.jsc-remove-gwp:not([name="jsc-tier-gwp"])').length > 0;
    var hasQtyGwpOps = hasQtyGwpAddOps || hasQtyGwpUpdateOps || hasQtyGwpRemoveOps;
    
    if (hasTierGwpOps || hasNormalGwpOps || hasQtyGwpOps) {
      e.preventDefault();
      console.log('Checkout blocked: Pending GWP operations detected', {
        tierGwp: { add: hasTierGwpAddOps, update: hasTierGwpUpdateOps, remove: hasTierGwpRemoveOps },
        normalGwp: { add: hasNormalGwpAddOps, update: hasNormalGwpUpdateOps, remove: hasNormalGwpRemoveOps, swap: hasNormalGwpSwapOps },
        qtyGwp: { add: hasQtyGwpAddOps, update: hasQtyGwpUpdateOps, remove: hasQtyGwpRemoveOps }
      });
      // Trigger the appropriate GWP functions to process the pending operations
      if (hasTierGwpOps && typeof tierGWP === 'function') {
        tierGWP();
      }
      if ((hasNormalGwpOps || hasQtyGwpOps) && typeof masterGWP === 'function') {
        masterGWP();
      }
      return false;
    }
    
    return true;
  });

  // Only intercept actual checkout button clicks (buttons with name="checkout")
  $(document).on('click', 'button[name="checkout"]', function(e) {
    // Check if any GWP operations are in progress
    if (window.tierGwpOperationInProgress || window.gwpOperationInProgress) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Checkout button blocked: GWP operations in progress');
      return false;
    }
    
    // Check for ALL pending GWP operations
    // Tier GWP
    var hasTierGwpAddOps = $('input[name="jsc-tier-gwp"][jsc-add-gwp]').length > 0;
    var hasTierGwpUpdateOps = $('input[name="jsc-tier-gwp"][jsc-update-gwp]').length > 0;
    var hasTierGwpRemoveOps = $('input[name="jsc-tier-gwp"][jsc-remove-gwp]').length > 0;
    var hasTierGwpOps = hasTierGwpAddOps || hasTierGwpUpdateOps || hasTierGwpRemoveOps;
    
    // Normal GWP
    var hasNormalGwpAddOps = $('.jsc-add-cart-gift').length > 0;
    var hasNormalGwpUpdateOps = $('.jsc-updateqty-cart-gift').length > 0;
    var hasNormalGwpRemoveOps = $('.jsc-remove-cart-gift').length > 0;
    var hasNormalGwpSwapOps = $('.jsc-remove-cart-gift-swap').length > 0 && $('.jsc-add-cart-gift-swap').length > 0;
    var hasNormalGwpOps = hasNormalGwpAddOps || hasNormalGwpUpdateOps || hasNormalGwpRemoveOps || hasNormalGwpSwapOps;
    
    // Qty GWP
    var hasQtyGwpAddOps = $('.jsc-add-gwp:not([name="jsc-tier-gwp"])').length > 0;
    var hasQtyGwpUpdateOps = $('.jsc-update-gwp:not([name="jsc-tier-gwp"])').length > 0;
    var hasQtyGwpRemoveOps = $('.jsc-remove-gwp:not([name="jsc-tier-gwp"])').length > 0;
    var hasQtyGwpOps = hasQtyGwpAddOps || hasQtyGwpUpdateOps || hasQtyGwpRemoveOps;
    
    if (hasTierGwpOps || hasNormalGwpOps || hasQtyGwpOps) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Checkout button blocked: Pending GWP operations detected');
      // Trigger the appropriate GWP functions to process the pending operations
      if (hasTierGwpOps && typeof tierGWP === 'function') {
        tierGWP();
      }
      if ((hasNormalGwpOps || hasQtyGwpOps) && typeof masterGWP === 'function') {
        masterGWP();
      }
      return false;
    }
  });
  initAddonUpsellTabsStickyTop();
});

jscCustomSearch = (evt) => {
  var value = $(evt).val().toLowerCase();

  // find the grid section (only inside the same page)
  var $grid = $(".jsc-custom-search-grid");

  console.log('valueeee',value);
  $grid.find(".columns .column").each(function() {
    var title = $(this).find(".column__heading").text().toLowerCase();
    var desc  = $(this).find(".column__text.rte").text().toLowerCase();

    if (value === "") {
      $(this).show(); // show all if empty
    } else {
      $(this).toggle(title.includes(value) || desc.includes(value));
    }
  });

}

triggerLLRewards= (e, target, id) => {
  var selector = '';

  if (target === 'reward') {
    selector = `[data-lion-rewards-list] [data-reward-id='${id}'] button.lion-action-button span`;
  } else {
    selector = `[data-lion-rules-list] [data-rule-id='${id}'] button.lion-action-button`;
  }
  var targetSpan = document.querySelector(selector);
  if (targetSpan && targetSpan.textContent.toLowerCase().includes('more points needed')) {
    // Change button label instead of redirect
    var label = $(e).find('span');
    if (label) {
      label.text('More points needed');
    }
  } else {
    // Trigger the actual LL popup button
    var targetButton = document.querySelector(selector)?.closest("button");
    targetButton?.click();
  }
}

initSplideAutoScroll = () => {
  var splides = $('.splide');
  if (splides.length) {
    for (var i = 0; i < splides.length; i++) {
      new Splide(splides[i], { // Pass splides[i] instead of $('.splide')
        type: 'loop',
        drag: 'free',
        focus: 'center',
        pagination: false,
        toggle: false,
        arrows: false,
        perPage: 4,
        autoScroll: {
          speed: 1,
          pauseOnHover: false,
        },
      }).mount( window.splide.Extensions );
    }
  }
}


tabChangeHeaderUrl = (e) => {
  var $this = $(e);
  var $collection_url = $this.attr('data-url');
  var $header = $this.closest('.grid__heading-holder');
  $header.find('.jsc-text-link').attr('href',$collection_url);
}

jscEqualizeProductGridnContainer = ($root) => {
  if (!$root || !$root.length) return;
  var $links = $root.find('.grid-item .product-item__info .product-link');
  var $subs = $root.find('.grid-item .product-item__info .jsc-product-item__subtitle');
  var $titles = $root.find('.grid-item .product-item__info .product-item__title');

  $links.css({ height: '', minHeight: '' });
  $subs.each(function() {
    this.style.removeProperty('--subheight');
  });
  $titles.each(function() {
    this.style.removeProperty('--titleheight');
  });

  var maxSub = 0;
  $root.find('.grid-item').each(function() {
    var $sub = $(this).find('.product-item__info .jsc-product-item__subtitle');
    if (!$sub.length) return;
    var sh = $sub.outerHeight();
    if (maxSub < sh) maxSub = sh;
  });
  if (maxSub > 0) {
    $subs.each(function() {
      this.style.setProperty('--subheight', maxSub + 'px');
    });
  }

  var maxTitle = 0;
  $root.find('.grid-item').each(function() {
    var $t = $(this).find('.product-item__info .product-item__title');
    if (!$t.length) return;
    var th = $t.height();
    if (maxTitle < th) maxTitle = th;
  });
  if (maxTitle > 0) {
    $titles.each(function() {
      this.style.setProperty('--titleheight', maxTitle + 'px');
    });
  }

  var maxLink = 0;
  $root.find('.grid-item').each(function() {
    var $link = $(this).find('.product-item__info .product-link');
    if (!$link.length) return;
    var h = $link.outerHeight();
    if (maxLink < h) maxLink = h;
  });
  if (maxLink > 0) {
    $links.css('height', maxLink + 'px');
  }
};

upsellGridHeight = () => {
  $('.drawer__body #appendCartUpsell .jsc-upsell-grid, .drawer__body #appendEmptyCartUpsell .jsc-upsell-grid').each(function() {
    jscEqualizeProductGridnContainer($(this));
  });
};

emptyUpsellGridHeight = () => {
  setTimeout(upsellGridHeight, 1000);
};

// Start split grid height - split section
sectionColListGridHeight = () => {
  setTimeout(() => {
    $('.jsc-col-list-grid--slider').each(function() {
      jscEqualizeProductGridnContainer($(this));
    });
  },500);
}   

sectionTextColumnGridHeight = () => {
  setTimeout(() => {
    $('.jsc-columns--slider').each(function(){
      var $section = $(this);
      var maxTitleHeight = 0;
      var maxContentHeight = 0;
      var maxColumnHeight = 0;
  
      // Reset heights to avoid compounding on repeated recalculations
      $section.find('.column .column__heading').css('height', 'auto');
      $section.find('.column .column__text').css('height', 'auto');

      var $columns = $section.find('.column');
      $columns.each(function(index, $col) {
        var titleHeight = $($col).find('.column__heading').height();
        if (maxTitleHeight < titleHeight) {
          maxTitleHeight = titleHeight;
        }

        var contentHeight = $($col).find('.column__text').height();
        if (maxContentHeight < contentHeight) {
          maxContentHeight = contentHeight;
        }
      });
      if (maxTitleHeight > 0) {
        $section.find('.column .column__heading').css('height', maxTitleHeight + 'px');
      }
      if (maxContentHeight > 0) {
        $section.find('.column .column__text').css('height', maxContentHeight + 'px');
      }

      $columns.each(function(index, $col) {
        var rect = $($col)[0].getBoundingClientRect();
        var columnHeight = rect.height;
        if (maxColumnHeight < columnHeight) {
          maxColumnHeight = columnHeight;
        }
      });
      if (maxColumnHeight > 0) {
        $section.find('.flickity-viewport').css('height', maxColumnHeight + 'px');
      }
    });
  }, 500);
}

sectionColGridHeight = () => {
  setTimeout(() => {
    $('.jsc-section-col-grid--slider').each(function() {
      jscEqualizeProductGridnContainer($(this));
    });
  },500);
}   
tabColGridHeight = () => {
  setTimeout(() => {
    $('.jsc-tab-grid--slider').each(function() {
      jscEqualizeProductGridnContainer($(this));
    });
  },500);
}   

gridHeight = () => {
  $('.jsc-grid--slider').each(function() {
    jscEqualizeProductGridnContainer($(this));
  });
}  


cartJSEvent = () => {
  $(document).on('cart.requestStarted', function(event, cart) {
    if (window.location.pathname == '/cart') {
      // $('.jsc-loader-overlay').removeAttr("style");
      $('.jsc-loader-overlay').show();
      $('.cart__checkout').attr('disabled',true);
    }
  });
  $(document).on('cart.requestComplete', function(event, cart) {
      hideShowUpsell();
      removeLeftoverMessageCard();
      if (window.location.pathname == '/cart') {
        // $('.jsc-loader-overlay').css("display","none");
        $('.jsc-loader-overlay').hide();
        $('.cart__checkout').removeAttr('disabled');
      }
  });
}

masterGWP = () => {
  removeOldGwpKey(); // will remove
  
  setTimeout(() => {
    masterAutoGwp();
    tierGWP();
    qtyGwp();
    hideShowUpsell();
    cartFreeShipping();
    gwp_progressbar();
    tier_gwp_progressbar();
    removeLeftoverMessageCard();
  }, 2000);    
}

gwp_progressbar = () =>{
  var $cart_subtotal = 0;
  var $qualifier = parseInt($('#__getGwpQualifier').val());

  $.when($.getJSON('/cart.js', function(cart) {
    $cart_subtotal = cart.original_total_price;
  })).then(function(cart){

    var xcldeArr = {};
    var $excludeTotal = 0;
    var cartItems = cart.items;
    

      for (var i = 0; i < cartItems.length; i++) {
        var _getHdle = '/products/'+cartItems[i].handle+'.js';
        xcldeArr[_getHdle] = cartItems[i].original_line_price;
      }
  
      $.each(xcldeArr, function(key,valueObj){
        jQuery.getJSON(key, function(product) {
          var lowercaseTags = product.tags.map(tag => tag.toLowerCase());  
          if (lowercaseTags.includes('mds30off2023') || lowercaseTags.includes('exclude gwp')) {
            $excludeTotal += valueObj;
          }
        });
      });

      setTimeout(function () {
        var $cartTotAfterExclude = $cart_subtotal - $excludeTotal;
        var $percentValue = $cartTotAfterExclude / $qualifier;
        var $percent = $percentValue * 100;
        var $gwp_left = $qualifier - $cartTotAfterExclude;
        // console.log($cartTotAfterExclude,'$cartTotAfterExclude');
        // console.log($excludeTotal,'excludeTotal');
        // console.log($gwp_left,'gwp_left');
    
        $('.__gwp_bar').val($percent);
      
        if ($gwp_left > 0){
          $gwp_left = ($gwp_left / 100).toFixed(2);
          $('.jsc-free-shipping__success-message').hide();
          $('.jsc-gwp--message .jsc-left-spend').text($gwp_left);
          $('.jsc-gwp--message').show();
        }
      
        if ($gwp_left <= 0){
          $('.jsc-gwp--message').hide();
          $('.jsc-free-shipping__success-message').show();
        }

      }, 1000);
  });

}

fs_progressbar = ($subtotal,$limit) =>{
  var $percentValue = $subtotal / $limit;
  var $percent = $percentValue * 100;

  $('._fs_bar').val($percent);
}

cartFreeShipping = () =>{
  var $left_spend = 0;
  var $cart_subtotal = 0;
  var $limitAmt = parseInt($('#_freeShippingAmt').val());

  $.when($.getJSON('/cart.js', function(cart) {
    $cart_subtotal = cart.total_price;
  })).then(function(){

    $left_spend = $limitAmt - $cart_subtotal;

    fs_progressbar($cart_subtotal,$limitAmt);

    if ($left_spend > 0){
      $left_spend = ($left_spend / 100).toFixed(2);
      $('.jsc-free-shipping__success-message').hide();
      $('.jsc-free-shipping__message .jsc-left-spend').text($left_spend);
      $('.jsc-free-shipping__message').show();
    }

    if ($left_spend < 0){
      $('.jsc-free-shipping__message').hide();
      $('.jsc-free-shipping__success-message').show();
    }

  });
}
hideShowUpsell = () =>{
  // initUpsellSlider();
  // initEmptyUpsellSlider();
    
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
  
        var count = cart.item_count;
  
      if (count == 0){
          $('#appendCartUpsell').hide();
          $('#appendEmptyCartUpsell').show();
          // console.log('show empty..',count);
          if (location.href.includes('/cart')) {
            $('._upsell-is-empty-cart').show();
            $('._upsell-is-cart').hide();
          }
      }else{
        $('#appendEmptyCartUpsell').hide();
        $('#appendCartUpsell').show();
        // console.log('show cart..',count);
        if (location.href.includes('/cart')) {
          $('._upsell-is-empty-cart').hide();
          $('._upsell-is-cart').show();
        }
      }


  
  });
}
destroyUpsellSlider = () =>{
  $('.jsc-init-slider').flickity();
  $('.jsc-init-slider').flickity('destroy');
}

$("#appendEmptyCartUpsell .jsc-init-slider .flickity-button").click(function() {
  alert("Button was clicked!");
});

initUpsellSlider = () =>{
  if ($(".jsc-init-slider").length > 0){
    $(".jsc-init-slider").flickity({
      cellAlign: 'right',
      groupCells: 2,
      adaptiveHeight: true,
      contain: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true
    });
  }

  // $(".jsc-init-slider").find('.next').click();
  $('#MainContent ._upsell-is-empty-cart').removeClass('jsc-before-upsell');
  $('#MainContent ._upsell-is-cart').removeClass('jsc-before-upsell');

  $('.drawer__body ._upsell-is-empty-cart').removeClass('jsc-before-upsell');
  $('.drawer__body ._upsell-is-cart').removeClass('jsc-before-upsell');

  // setTimeout(function(){
    upsellGridHeight();
  // },1000); 

  hideShowUpsell();

}

$(document).on('click', '.filter-group input', function () { 
  setTimeout(function(){
    collectionGridHeight(); 
  },3000); 
});

initEmptyUpsellSlider = () =>{
  if ($(".jsc-init-slider").length > 0){
    $(".jsc-init-slider").flickity({
      cellAlign: 'left',
      adaptiveHeight: true,
      groupCells: 2,
      contain: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true
    });
  }

  $(".jsc-init-slider").find('.next').click();
  $('#MainContent ._upsell-is-empty-cart').removeClass('jsc-before-upsell');
  $('#MainContent ._upsell-is-cart').removeClass('jsc-before-upsell');

  $('.drawer__body ._upsell-is-empty-cart').removeClass('jsc-before-upsell');
  $('.drawer__body ._upsell-is-cart').removeClass('jsc-before-upsell');

  setTimeout(function(){
    emptyUpsellGridHeight();
  },1000); 

  hideShowUpsell();

}

renderCartUpsell = () => {
  destroyUpsellSlider();
  var $isCartId = $('._upsell-is-cart').attr('data-section-id');
  var $isEmptyCartId = $('._upsell-is-empty-cart').attr('data-section-id');
 
  if ($isCartId){
    if ($("#appendCartUpsell").children().length == 0){
      fetch(window.Shopify.routes.root + "?sections="+$isCartId)
      .then(res => res.json())
      .then((data) => {
        $('#appendCartUpsell').append(data[$isCartId]);
          // upsellGridHeight();
          // setTimeout(function(){
            initUpsellSlider();
          // },500); 
      });
    }
  }


  if ($isEmptyCartId){
    if ($("#appendEmptyCartUpsell").children().length == 0){
      fetch(window.Shopify.routes.root + "?sections="+$isEmptyCartId)
      .then(res => res.json())
      .then((data) => {
        $('#appendEmptyCartUpsell').append(data[$isEmptyCartId]);
   
        // setTimeout(function(){
          initEmptyUpsellSlider();
        // },3000)

      });
    }
  }
} 

checkGwpOptStatus = () => {
  var $opt_status = sessionStorage.getItem("optFreeGift");
  if ($opt_status != null){
    $('.gwp--progress-bar-wrapper').hide();
    $('#__optRemoveGwp').prop('checked', true);
  }
}

checkTierGwpOptStatus = () => {
  var $opt_status = sessionStorage.getItem("optTierFreeGift");
  if ($opt_status != null){
    $('.tier-gwp--progress-bar-wrapper').hide();
    $('#__optRemoveTierGwp').prop('checked', true);
  }
}
optRemoveGwp =  () => {
  sessionStorage.setItem("optFreeGift", "Remove");
  $('.gwp--progress-bar-wrapper').hide();
  var $vid = $('#jsc-cart-gift-prod').val();
  cartJSUpdateQuery($vid, 0, {});
  CartJS.setAttributes({"Tick to opt out and remove gift with purchase":"Yes"});
}

optRemoveTierGwp = () => {
  sessionStorage.setItem("optTierFreeGift", "Remove");
  $('.tier-gwp--progress-bar-wrapper').hide();
  var $tierGwpProduct = $('input[name="jsc-tier_gwp_product"]');
  $tierGwpProduct.each(function() {
    var $vid = parseInt($(this).val());
    cartJSUpdateQuery($vid, 0, {});
  });
  CartJS.setAttributes({"Tick to opt out and remove tier gift with purchase":"Yes"});
}

resetOptRemove = () => {
  $.when($.getJSON('/cart.js', function(cart) {
  })).then(function(cart){
    var cartAttr = cart.attributes;
    delete cartAttr['Tick to opt out and remove gift with purchase'];
    delete cartAttr['Tick to opt out and remove tier gift with purchase'];
    CartJS.clearAttributes();
    CartJS.setAttributes(cartAttr);
    sessionStorage.removeItem("optFreeGift");
    sessionStorage.removeItem("optTierFreeGift");
    $('.gwp--progress-bar-wrapper').show();
  });
}

// resetOptRemoveTierGwp = () => {
//   $.when($.getJSON('/cart.js', function(cart) {
//   })).then(function(cart){
//     var cartAttr = cart.attributes;
//     delete cartAttr['Tick to opt out and remove tier gift with purchase'];
//     CartJS.clearAttributes();
//     CartJS.setAttributes(cartAttr);
//     sessionStorage.removeItem("optTierFreeGift");
//     $('.tier-gwp--progress-bar-wrapper').show();
//     // Uncheck the checkbox
//     $('#__optRemoveTierGwp').prop('checked', false);
//   });
// }

toggleGwpProgressBar = () => {
  var $opt_status = sessionStorage.getItem("optFreeGift");
  var $progressBar = $('.gwp--progress-bar-wrapper');
  var $showProgressBarInput = $('.jsc-gwp-show-progress-bar');

  if ($opt_status != null || $showProgressBarInput.val() == 'false') {
    $progressBar.hide();
  } else {
    $progressBar.show();
  }
}

toggleTierGwpProgressBar = () => {
  var $opt_status = sessionStorage.getItem("optTierFreeGift");
  var $progressBar = $('.tier-gwp--progress-bar-wrapper');

  if ($opt_status != null) {
    $progressBar.hide();
  } else {
    $progressBar.show();
  }
}

removeOldGwpKey = () => {

  $.when($.getJSON('/cart.js', function(cart) {
    $cartItems = cart.items;

 })).then(function(){

   for (var i = 0; i < $cartItems.length; i++) {
       var $oldGwp1InCart = false;
       var $oldGwp2InCart = false;
       var $vid = $cartItems[i].key;

       if ($cartItems[i] && $cartItems[i].properties && $cartItems[i].properties['_Gift Box']) {
        $oldGwp1InCart =  $cartItems[i].properties['_Gift Box'];
       }

       if ($cartItems[i] && $cartItems[i].properties && $cartItems[i].properties['GWP Product']) {
        $oldGwp2InCart = $cartItems[i].properties['GWP Product'];
       }

       if(($oldGwp1InCart) || ($oldGwp2InCart)){
         cartJSUpdateQuery($vid, 0, {});
       }

   }

 });
}

// Global flag to track if normal GWP operations are in progress
window.gwpOperationInProgress = false;

masterAutoGwp = () => {
  // console.log('runn');
  var $optRemoveGwp = sessionStorage.getItem("optFreeGift");
  toggleGwpProgressBar();
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){

      var $gwpcart_product = {};
      var $addEle = $('.jsc-add-cart-gift');
      var $removeEle = $('.jsc-remove-cart-gift');
      var $updateEle = $('.jsc-updateqty-cart-gift');
      var $removeSwapEle = $('.jsc-remove-cart-gift-swap');
      var $addSwapEle = $('.jsc-add-cart-gift-swap');
      var cartAttr = cart.attributes;
  
      $gwpcart_product['_GWP Product'] = 'true';
      
      // Check for any GWP operations and set flag to block checkout
      // This ensures customers get their entitled GWP (add) and don't checkout with unqualified GWP (remove)
      var hasAddOps = $addEle.length > 0;
      var hasRemoveOps = $removeEle.length > 0;
      var hasUpdateOps = $updateEle.length > 0;
      var hasSwapOps = $removeSwapEle.length > 0 && $addSwapEle.length > 0;
      
      if (hasAddOps || hasRemoveOps || hasUpdateOps || hasSwapOps) {
        window.gwpOperationInProgress = true;
        $('button[name="checkout"].cart__checkout').attr('disabled', true);
      }
      
      // Swap GWP product when currency changes (remove wrong one, add correct one)
      if ($removeSwapEle.length > 0 && $addSwapEle.length > 0){
        var $vidRemoveSwap = parseInt($removeSwapEle.val());
        var $vidAddSwap = parseInt($addSwapEle.val());
        var $vidRemoveSwapQty = 0;
        var $vidAddSwapQty = 1;
        
        if ($optRemoveGwp != "Remove"){
          $('.jsc-loader-overlay').show();
          $('button[name="checkout"].cart__checkout').attr('disabled',true);
          
          // Store swap info in global variable for callback
          window.gwpSwapPending = {
            vid: $vidAddSwap,
            qty: $vidAddSwapQty,
            props: $gwpcart_product,
            cartAttr: cartAttr
          };
          
          // First remove the wrong GWP product - the success callback will add the correct one
          CartJS.updateItemById($vidRemoveSwap, $vidRemoveSwapQty, {},
          {
            "success": function(data, textStatus, jqXHR) {
              $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function(cart) {
                  removeLeftoverMessageCard();
                  // Now add the correct GWP product
                  if (window.gwpSwapPending) {
                    CartJS.setAttributes({"Tick to opt out and remove gift with purchase":"No"});
                    if (window.gwpSwapPending.cartAttr.hasOwnProperty('Opt and Remove Gwp')){
                      delete window.gwpSwapPending.cartAttr['Opt and Remove Gwp'];
                      CartJS.clearAttributes();
                      CartJS.setAttributes(window.gwpSwapPending.cartAttr);
                    }
                    cartJSAddQuery(window.gwpSwapPending.vid, window.gwpSwapPending.qty, window.gwpSwapPending.props);
                    window.gwpSwapPending = null;
                  } else {
                    getThis.getCart();
                    window.gwpOperationInProgress = false;
                    $('.jsc-loader-overlay').hide();
                    $('.cart__checkout').removeAttr('disabled');
                  }
                }
              });
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              window.gwpOperationInProgress = false;
              $('.cart__checkout').removeAttr('disabled');
              $('.jsc-loader-overlay').hide();
              window.gwpSwapPending = null;
            }
          });
        }
        return; // Exit early to prevent other GWP operations
      }
      
        // add gwp
        if ($addEle.length > 0){
          var $vidAdd = parseInt($addEle.val());
          var $vidAddQty = 1;
          if ($optRemoveGwp != "Remove"){

           
            CartJS.setAttributes({"Tick to opt out and remove gift with purchase":"No"});
            if (cartAttr.hasOwnProperty('Opt and Remove Gwp')){
              delete cartAttr['Opt and Remove Gwp'];
              CartJS.clearAttributes();
              CartJS.setAttributes(cartAttr);
            }
            $('.jsc-loader-overlay').show();
            $('.cart__checkout').attr('disabled',true);
            cartJSAddQuery($vidAdd, $vidAddQty, $gwpcart_product);      
          }else{
            CartJS.setAttributes({"Tick to opt out and remove gift with purchase":"Yes"});
            if (cartAttr.hasOwnProperty('Opt and Remove Gwp')){
              delete cartAttr['Opt and Remove Gwp'];
              CartJS.clearAttributes();
              CartJS.setAttributes(cartAttr);
            }
          }
        }
  
        // update qty if bug happen
        if ($updateEle.length > 0){  
         
          var $vidUpdate = parseInt($updateEle.val());
          var $vidUpdateQty = 1;
          if ($optRemoveGwp != "Remove"){
          console.log($vidUpdateQty,'update qty git..');
          $('.jsc-loader-overlay').show();
          $('.cart__checkout').attr('disabled',true);
          cartJSUpdateQuery($vidUpdate, $vidUpdateQty, $gwpcart_product);
          }
        }
  
      // remove gwp
      if ($removeEle.length > 0){ 
       
        var $vidRemove = parseInt(($removeEle).val());
        var $vidRemoveQty = 0;
        console.log($vidRemove,'remove qty git..');
        window.gwpOperationInProgress = true;
        $('.jsc-loader-overlay').show();
        $('button[name="checkout"].cart__checkout').attr('disabled',true);
        cartJSUpdateQuery($vidRemove, $vidRemoveQty, {});
        if (cartAttr.hasOwnProperty('Tick to opt out and remove gift with purchase')){
          delete cartAttr['Tick to opt out and remove gift with purchase'];
          CartJS.clearAttributes();
          CartJS.setAttributes(cartAttr);
      }
      };
  
      var $gwpNotEligible = $('.jsc-cart-gift-not-eligible');
      if ($gwpNotEligible.length > 0){
        CartJS.setAttributes({"Tick to opt out and remove gift with purchase":"NA"});
        if (cartAttr.hasOwnProperty('Opt and Remove Gwp')){
            delete cartAttr['Opt and Remove Gwp'];
            CartJS.clearAttributes();
            CartJS.setAttributes(cartAttr);
        }
      }

      var $gwpDisabled = $('.jsc-cart-gift-disabled');
      if ($gwpDisabled.length > 0){
        if (cartAttr.hasOwnProperty('Opt and Remove Gwp')){
            delete cartAttr['Opt and Remove Gwp'];
            CartJS.clearAttributes();
            CartJS.setAttributes(cartAttr);
        }
        if (cartAttr.hasOwnProperty('Tick to opt out and remove gift with purchase')){
          delete cartAttr['Tick to opt out and remove gift with purchase'];
          CartJS.clearAttributes();
          CartJS.setAttributes(cartAttr);
      }
      }
  });
}


qtyGwp = () => {

    $.when($.getJSON('/cart.js', function(cart) {
        
    })).then(function(cart){
        var $gwpcart_product = {};
        var $addEle = $('.jsc-add-gwp');
        var $updateEle = $('.jsc-update-gwp');
        var $deleteEle = $('.jsc-remove-gwp');
    
        $gwpcart_product['_Promo'] = 'Free Gift';
    
        $addEle.each(function() {
        
        var $vid = parseInt($(this).val());
        var $qty = parseInt($(this).attr('data-qty'));
    
        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');
        $('.jsc-loader-overlay').show();
        $('.cart__checkout').attr('disabled',true);
        cartJSAddQuery($vid, $qty, $gwpcart_product);
        });
    
        $updateEle.each(function() {
        
        var $vid = $(this).val();
        var $qty = parseInt($(this).attr('data-qty'));
    
        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');
        $('.jsc-loader-overlay').show();
        $('.cart__checkout').attr('disabled',true);
        cartJSUpdateQuery($vid, $qty, $gwpcart_product);
        });
    
        $deleteEle.each(function() {
        
        var $vid = $(this).val();
        var $qty = 0;
        $('.cart__checkout').attr('disabled',true);
        $('.jsc-loader-overlay').show();
        cartJSUpdateQuery($vid, $qty, {});
        });
    
    });

}


cartJSUpdateQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback
  cartJSEvent();

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
        },
        success: function(cart) {
          removeLeftoverMessageCard();
          getThis.getCart();
          // Clear GWP operation flag after cart refresh
          setTimeout(function() {
            window.gwpOperationInProgress = false;
            $('.jsc-loader-overlay').hide();
            $('.cart__checkout').removeAttr('disabled');
          }, 300);
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      window.gwpOperationInProgress = false;
      $('.cart__checkout').removeAttr('disabled');
      $('.jsc-loader-overlay').hide();
    }
  });
}

cartJSAddQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback
  cartJSEvent();


  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          removeLeftoverMessageCard();
          getThis.getCart();
          // Clear GWP operation flag after cart refresh
          setTimeout(function() {
            window.gwpOperationInProgress = false;
            $('.cart__checkout').removeAttr('disabled');
            $('.jsc-loader-overlay').hide();
          }, 300);
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      window.gwpOperationInProgress = false;
      $('.cart__checkout').removeAttr('disabled');
      $('.jsc-loader-overlay').hide();
    }
  });
}

cartJSUpdateQuantity = (items) => {
  cartJSEvent();

  CartJS.updateItemQuantitiesById(items, {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          removeLeftoverMessageCard();
          getThis.getCart();
          $('.cart__checkout').removeAttr('disabled');
          $('.jsc-loader-overlay').hide();

          const newCartCount = cart.item_count;
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              bubbles: true,
              detail: {
                cartCount: newCartCount
              }
            })
          );
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      $('.cart__checkout').removeAttr('disabled');
      $('.jsc-loader-overlay').hide();
    }
  });
}

cartjsAdd = (evt,vid) =>{
    var e = $(evt);
    $('.jsc-loader-overlay').show();
    var packagingActive = e.attr('data-extra-packaging-active') === 'true';
    var packagingVariantId = e.attr('data-extra-packaging-variant-id');
    var packagingMainTitle = e.attr('data-extra-packaging-main-title') || '';

    if (packagingActive && packagingVariantId) {
      e.addClass('is-loading');
      var seconds = new Date().getTime() / 1000;
      var bundleID = vid + '-' + seconds;
      var mainItem = {
        'id': vid,
        'quantity': 1,
        'properties': {
          '_BundleID': bundleID
        }
      };
      var items = [mainItem];
      var packagingLineItem = getExtraPackagingItemForProduct(packagingVariantId, bundleID, 1, packagingMainTitle);
      if (packagingLineItem) {
        items.push(packagingLineItem);
      }
      CartJS.addItems(items,
      {
        'success': function() {
          setTimeout(function(){
            e.removeClass('is-loading');
            e.addClass('is-added');
          }, 500);
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success: function() {
              removeLeftoverMessageCard();
              getThis.getCart();
              masterGWP();
              updatePWP();
              $('.jsc-loader-overlay').hide();
            },
            error: function() {
              $('.jsc-loader-overlay').hide();
            }
          });
        },
        'error': function() {
          e.removeClass('is-loading');
          $('.jsc-loader-overlay').hide();
        }
      });
      $(document).one('cart.requestComplete', function() {
        e.removeClass('is-added');
      });
      return;
    }

    e.addClass('is-loading');
    setTimeout(function(){
        e.removeClass('is-loading');
        e.addClass('is-added');
    },500);

    CartJS.addItem(vid, 1);

    $(document).on('cart.requestComplete', function(event, cart) {
        e.removeClass('is-added');
        removeLeftoverMessageCard();
        getThis.getCart();
        $('.jsc-loader-overlay').hide();
        // masterGWP();
    });
}

/**
 * When the main line or extra-packaging line quantity changes, update both in one CartJS request.
 * @returns {boolean} true if an extra-packaging pair was handled (CartJS called).
 */
cartJSUpdateExtraPackagingBundleQuantities = (cartItemEl, newQty) => {
  var partner = findExtraPackagingBundlePartnerLine(cartItemEl);
  if (!partner) {
    return false;
  }
  var items = {};
  items[cartItemEl.getAttribute('data-key')] = newQty;
  items[partner.getAttribute('data-key')] = newQty;
  cartJSUpdateQuantity(items);
  return true;
};

/**
 * Finds the paired cart line for extra-packaging bundles: main product line ↔ line with _ExtraPackaging.
 * Skips message-card lines so their quantity is not tied to the packaging line.
 */
findExtraPackagingBundlePartnerLine = (cartItemEl) => {
  if (!cartItemEl || !cartItemEl.getAttribute) {
    return null;
  }
  var bundleId = cartItemEl.getAttribute('bundle-id');
  if (!bundleId) {
    return null;
  }
  var nodes = document.querySelectorAll('.cart__item[data-key]');
  var i;
  if (cartItemEl.hasAttribute('is-extra-packaging')) {
    for (i = 0; i < nodes.length; i++) {
      var nMain = nodes[i];
      if (nMain.getAttribute('bundle-id') !== bundleId || nMain === cartItemEl) {
        continue;
      }
      if (!nMain.hasAttribute('is-extra-packaging') && !nMain.hasAttribute('is-message-card')) {
        return nMain;
      }
    }
  } else if (!cartItemEl.hasAttribute('is-message-card')) {
    for (i = 0; i < nodes.length; i++) {
      var nPackaging = nodes[i];
      if (nPackaging.getAttribute('bundle-id') !== bundleId || nPackaging === cartItemEl) {
        continue;
      }
      if (nPackaging.hasAttribute('is-extra-packaging')) {
        return nPackaging;
      }
    }
  }
  return null;
};

initExtraPackagingCollectionQuickAdd = () => {
  document.addEventListener('click', function(clickEvt) {
    var btn = clickEvt.target.closest('[data-add-to-cart]');
    if (!btn) {
      return;
    }
    var holder = btn.closest('[data-quick-add-holder]');
    if (!holder || holder.getAttribute('data-extra-packaging-active') !== 'true') {
      return;
    }
    var packagingVariantId = holder.getAttribute('data-extra-packaging-variant-id');
    var packagingMainTitle = holder.getAttribute('data-extra-packaging-main-title') || '';
    if (!packagingVariantId) {
      return;
    }
    var form = btn.closest('form');
    if (!form) {
      return;
    }
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) {
      return;
    }
    var mainVariantId = parseInt(idInput.value, 10);
    if (!mainVariantId) {
      return;
    }
    clickEvt.preventDefault();
    clickEvt.stopPropagation();
    clickEvt.stopImmediatePropagation();
    $('.jsc-loader-overlay').show();
    var $btn = $(btn);
    btn.disabled = true;
    $btn.addClass('is-loading');
    if (holder.classList) {
      holder.classList.add('is-visible');
    }
    var seconds = new Date().getTime() / 1000;
    var bundleID = mainVariantId + '-' + seconds;
    var mainItem = {
      'id': mainVariantId,
      'quantity': 1,
      'properties': {
        '_BundleID': bundleID
      }
    };
    var items = [mainItem];
    var packagingLineItem = getExtraPackagingItemForProduct(packagingVariantId, bundleID, 1, packagingMainTitle);
    if (packagingLineItem) {
      items.push(packagingLineItem);
    }
    CartJS.addItems(items,
    {
      'success': function() {
        btn.dispatchEvent(
          new CustomEvent('theme:product:add', {
            detail: {
              response: null,
              button: btn
            },
            bubbles: true
          })
        );
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success: function() {
            removeLeftoverMessageCard();
            if (typeof getThis !== 'undefined' && getThis.getCart) {
              getThis.getCart();
            }
            if (typeof masterGWP === 'function') {
              masterGWP();
            }
            if (typeof updatePWP === 'function') {
              updatePWP();
            }
            $('.jsc-loader-overlay').hide();
          }
        });
      },
      'error': function() {
        btn.disabled = false;
        $btn.removeClass('is-loading');
        if (holder.classList) {
          holder.classList.remove('is-visible');
        }
        $('.jsc-loader-overlay').hide();
      }
    });
  }, true);
};

  //PDP Gift Wrap Info Popup
  function initGiftWrapInfoPopup() {
    const popuplinker = document.querySelector(".js-modal-open-giftwrap-info");
    if (popuplinker !== null) {
      $(".js-modal-open-giftwrap-info").magnificPopup({
        type: "inline",
        midClick: true,
      });
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    initGiftWrapInfoPopup();
  });

  //Account page 
  anchorToMyReward = () =>{
      if (window.location.hash === '#account-loyality') {
      $('html').animate({
        scrollTop: $("#account-loyality").offset().top - 150
      }, 1000);
    }
  }

  getHash = (e) => {
    var hash = $(e).attr('data-anchor');
    if(hash == "" || hash == null || hash == undefined) {
      sessionStorage.removeItem('anchor-tag');
    }
    else {
      sessionStorage.setItem('anchor-tag', hash);
    }
  }

  accountPageAnchor = () => {
    if(window.location.pathname === '/account') {
      var hash = sessionStorage.getItem('anchor-tag');
      if(hash != null) {
        hash = hash.replace(/#/g, '');
        window.location.hash = hash;
        sessionStorage.removeItem('anchor-tag');
      }

      if(window.location.hash == "#get-reward") {
        var intervalID = setInterval(() => {
          var $getReward = $('#loyaltylion .lion-rewards-list');
          if($getReward.length > 0) {
            $('html').animate({
              scrollTop: $($getReward).offset().top - 200
            }, 1000);
  
            clearInterval(intervalID);
          }
        }, 100);
      }
      else if(window.location.hash == "#refer-friend") {
        var intervalID = setInterval(() => {
          var $referFriend = $('#loyaltylion .lion-rules-list');
          if($referFriend.length > 0) {
            $('html').animate({
              scrollTop: $($referFriend).offset().top - 200
            }, 1000);
  
            clearInterval(intervalID);
          }
        }, 100);
      }
    }
  }

  //PDP Find in Store
  expandFindInStore = () =>{
 
    var anchr = $('#jscAnchrFdStore').parent().children('.accordion__body');
   
     if (anchr.length > 0) {
      $('.form__wrapper .accordion').removeAttr('open');
      $('#jscAnchrFdStore').parent().children('.accordion__body').css('height','auto');
      $('#jscAnchrFdStore').parent('.accordion').attr('open','true');
 

      $('html').animate({
          scrollTop: $("#jscAnchrFdStore").offset().top - 150
      }, 1000);

     }
   
   } 

   // Giftmessage Line Item script start here
toggle_textarea = (evt, key, p, vid) => {

  var $propObj = JSON.parse(p);
  var path = $(evt).parents(".jsc__giftwrap").find(".textarea__giftwrap");
  var path2 = $(evt).parents(".jsc__giftwrap").find(".line_item_properties");
  var path3 = $(evt).parents(".jsc__giftwrap").find(".jsc_save_giftmessage");
  
  var $intVid = parseInt(vid);
  var $qtyField = $(evt).parents('.cart__item').find('.cart__quantity-field');
  var $qty = parseInt($qtyField.val());
  
  console.log($propObj,'$propObj',$intVid,'intVid',$qty,'$qty');
  
  if ($(evt).prop("checked") == true) {
    path.show();
    path3.show();
  
    var inputData = path2.val();
    $propObj["Complimentary gift message"] = inputData;
    console.log(inputData,'$inputData proeprrtes');
    if (inputData != '') {
      CartJS.updateItemById(key, qty, $propObj,
        {
          // Define a success callback to display a success message.
          "success": function(data, textStatus, jqXHR) {
            $.ajax({
              url: '/cart.js',
              dataType: "json",
              cache: false,
              beforeSend: function() {
              },
              success: function(cart) {
                getThis.getCart();
                $('.cart__checkout').removeAttr('disabled');
                $('.jsc-loader-overlay').hide();
              }
            });
          },
          // Define an error callback to display an error message.
          "error": function(jqXHR, textStatus, errorThrown) {
            $('.cart__checkout').removeAttr('disabled');
            $('.jsc-loader-overlay').hide();
          }
        });
    }
  } 
  else if ($(evt).prop("checked") == false) {
    path.hide();
    path3.hide();
    delete $propObj["Complimentary gift message"];
    console.log('toggle checked false check',$.isEmptyObject($propObj));
    if ($.isEmptyObject($propObj)) {
      // CartJS.updateItemById(key, 0, {},
      //   {
      //     // Define a success callback to display a success message.
      //     "success": function(data, textStatus, jqXHR) {
      //       $.ajax({
      //         url: '/cart.js',
      //         dataType: "json",
      //         cache: false,
      //         beforeSend: function() {
      //         },
      //         success: function(cart) {
      //           getThis.getCart();
      //           $('.cart__checkout').removeAttr('disabled');
      //           $('.jsc-loader-overlay').hide();
 
      //         }
      //       });
      //     },
      //     // Define an error callback to display an error message.
      //     "error": function(jqXHR, textStatus, errorThrown) {
      //      $('.cart__checkout').removeAttr('disabled');
      //      $('.jsc-loader-overlay').hide();
      //     }
      //   });
    } 
    else {
      CartJS.updateItemById(key, $qty, $propObj,
        {
          // Define a success callback to display a success message.
          "success": function(data, textStatus, jqXHR) {
            $.ajax({
              url: '/cart.js',
              dataType: "json",
              cache: false,
              beforeSend: function() {
              },
              success: function(cart) {
                getThis.getCart();
                $('.cart__checkout').removeAttr('disabled');
                $('.jsc-loader-overlay').hide();
              }
            });
          },
          // Define an error callback to display an error message.
          "error": function(jqXHR, textStatus, errorThrown) {
            $('.cart__checkout').removeAttr('disabled');
            $('.jsc-loader-overlay').hide();
          }
        });
    } 
  }
  
  }
  
  update_line_item = (evt, key,vid, p) => {
  var $propObj = JSON.parse(p);
  var inputData = $(evt).parents(".jsc__giftwrap").find(".line_item_properties").val();
  delete $propObj['Complimentary gift message'];
  
  $propObj["Complimentary gift message"] = inputData;
  
  var $qtyField = $(evt).parents('.cart__content').find('.cart__quantity-field');
  var $qty = parseInt($qtyField.val());
   
      CartJS.updateItemById(key, $qty, $propObj,
        {
          // Define a success callback to display a success message.
          "success": function(data, textStatus, jqXHR) {
            $.ajax({
              url: '/cart.js',
              dataType: "json",
              cache: false,
              beforeSend: function() {
              },
              success: function(cart) {
                getThis.getCart();
                $('.cart__checkout').removeAttr('disabled');
                $('.jsc-loader-overlay').hide();
              }
            });
          },
          // Define an error callback to display an error message.
          "error": function(jqXHR, textStatus, errorThrown) {
            $('.cart__checkout').removeAttr('disabled');
            $('.jsc-loader-overlay').hide();
          }
      });
  
  }

  characters_count = (evt ,vid ) => {
    var $path = $(evt).parents(".jsc__giftwrap").find(".count_characters");
    var $characters_count = $(evt).val().length;
    $path.text($characters_count);

    var path2 = "#textarea-"+vid;
    $(evt).parents(path2).find(".jsc_save_giftmessage").removeClass("actived");
    $(evt).parents(path2).find(".jsc_save_giftmessage").text('SAVE');
    console.log( $(evt).parents(path2),'dd');
    var currentVal = $(evt).val();
    if(currentVal != '') {
      $(evt).parents(".jsc__giftwrap").find(".jsc-btn-save-message").removeClass('disabled');
    }
    else {
      $(evt).parents(".jsc__giftwrap").find(".jsc-btn-save-message").addClass('disabled');
    }
  }

  $(document).ready(function() {
    collectionGridHeight();
    if($('.product__page .product__content .product__block--buttons').length > 0) {
      if($('.product__page .product__content .okeReviews--theme').length > 0) {
        $('.product__page .product__content .product__block--buttons').css({
          'padding-top': '0'
        })
      }
      else {
        $('.product__page .product__content .product__block--buttons').css({
          'padding-top': '20px'
        })
      }
    }
    
    if($(window).width() < 481){
      var element = $('.cart #main_cart_packaging .subheading');
      var brElement = element.find('br');
      if(brElement.length > 1){
        $(brElement[1]).remove()
      }
    }
  })
  
  collectionGridHeight = () => {
    $('.collection__products .grid-outer .grid').each(function() {
      jscEqualizeProductGridnContainer($(this));
    });
  }

  showBisBtn = (e) => {
    if ($('body').is('#gift-card')) return;
    // Skip legacy BIS/ATC toggle for featured gift card section (theme handles variant state there).
    if ($(e).closest('.section-featured-product[product-handle="giftcard"]').length) return;

    var inputElement = $(e).siblings('input');
    var isAvailable = inputElement.attr('data-available-online');
    var atcButton = $('.product__block--buttons .product__submit__buttons .jsc-pdp-atc');
    var bisButton = $('.product__block--buttons .product__submit__buttons .jsc-pdp-bis');
    var variantId = inputElement.val();

    if (variantId && bisButton.length) {
      bisButton.attr('data-variant-id', variantId);
    }

    if (isAvailable == 'true' || $('.jsc-block-swatch-hidden').length > 0) {
      atcButton.show();
      bisButton.hide();
    } else {
      atcButton.hide();
      bisButton.show();
    }
  }

// change pdp image based on variant start
getAllProductImage = () => {
  $(".product__slide").each(function () {
    var slideContent = $(this);
    productImgArray = productImgArray.concat(slideContent);
  });
};

getAllThumbImage = () => {
  $(".product__thumb").each(function () {
    var slideContent = $(this);
    thumbImgArray = thumbImgArray.concat(slideContent);
  });
};

initProductSlider = (slider) => {
  $(slider).flickity({
    pageDots: false,
    draggable: true,
    contain: true,
    cellAlign: "left"
  });
}

destroyProductSlider = (slider) => {
  $(slider).flickity('destroy');
}

linkThumbnail = () => {
  $(".jsc_product__thumbs__holder").on( 'click', '.product__thumb', function() {
    var index = $(this).index();
    $(".jsc_product__thumbs__holder").find('.is-active').removeClass('is-active');
    $(this).addClass('is-active');
    $(".product__slides").flickity('select', index );
  });
}

linkMainImage = () => {
  $(".product__slides").on('change.flickity', function(event, index) {
    $(".product__thumb").each(function (thumbIndex) {
      if(thumbIndex == index){
        var selectedThumb = $(this);
        selectedThumb.click();
        $(".jsc_product__thumbs__holder").flickity('select', thumbIndex );
      }
    });
  });
}

updateVariantImg = (option) => {
  var $variantPicker = $(option).parents('.jsc-variant-picker-block');
  var productTitle = $(option).parents('.jsc-variant-picker-block').attr('product-title');
  if ($(window).width() < 481){
    var currentVariant = $(option).siblings('input').val(); // current variant data-img-alt value
    var productCarousel = $(".product__slides"); // main slider
    var thumbnailCarousel = $('.jsc_product__thumbs__holder'); // thumbnail slider

    // destroy slider
    initProductSlider(productCarousel);
    destroyProductSlider(productCarousel);

    // remove all images
    var productImages = $(".product__slide");
    productImages.remove();
    var thumbnailImages = $(".product__thumb");
    thumbnailImages.remove();

    // reinitiate flickity with selected images
    initProductSlider(productCarousel);
    initProductSlider(thumbnailCarousel);
    for(var i = 0; i < productImgArray.length; i++) {
      var altText = productImgArray[i].attr("data-img-alt");
      if (altText == 'Birthstone Main' || altText == productTitle) {
        $(".product__slides .flickity-slider").append(productImgArray[i]);
        $('.jsc_product__thumbs__holder .flickity-slider').append(thumbImgArray[i]);
      }
      
      if (!$variantPicker.hasClass('hide')) {
        if (altText == currentVariant) {
          $(".product__slides .flickity-slider").append(productImgArray[i]);
          $('.jsc_product__thumbs__holder .flickity-slider').append(thumbImgArray[i]);
        }
      }
    }
    destroyProductSlider(productCarousel);
    initProductSlider(productCarousel);
    destroyProductSlider(thumbnailCarousel);
    initProductSlider(thumbnailCarousel);
    linkThumbnail();
    linkMainImage();
  }
  else {
    var input = $(option).siblings('input');
    var value = $(input).val();
    var productImages = $('.template-product .product__images .product__slides .product__slide');
    $.each(productImages, function(index, img) {
      var thisImg = $(img);
      var imgAltText = thisImg.data('img-alt');

      console.log('imgAltText', imgAltText);

      if ($variantPicker.hasClass('hide')) {
        if (imgAltText != 'Birthstone Main' && imgAltText != productTitle) {
          thisImg.css('display', 'none');
        }
      }
      else {
        if(imgAltText != 'Birthstone Main' && imgAltText != productTitle){
          if(imgAltText != value){
            thisImg.css('display', 'none');
          }
          else{
            thisImg.css('display', 'block');
          }
        }
      }
    });
  }
}

onLoadUpdateVariantImg = () => {
  var currentVariant = $('#jsc-onload-variant').val();
  if (currentVariant == null || currentVariant === '') return;

  var optionInput = $('.template-product .product__selectors .selector-wrapper .radio__buttons')
    .find('input[data-index="option1"]')
    .filter(function () {
      return $(this).val() === currentVariant;
    })
    .first();

  var optionLabel = optionInput.siblings('label');
  if (optionLabel.length) {
    optionLabel.trigger('click');
  }

  setupVariantOption(optionInput.val() || currentVariant);
}
// change pdp image based on variant end

// start: account page view reward points
rewardAnchorPos = () => {
  setTimeout(() => {
    var $loyaltyPoints = $('.loyalty__points');
    var width = $loyaltyPoints.width() + 30;
    var $viewRewardPoint = $('.jsc-view-reward-point');

    if($(window).width() > 1024) { // desktop +50
      width = width + 50;
      $viewRewardPoint.css('left', width + 'px');
    }
    else if($(window).width() > 480) { // ipad + 30
      width = width + 30;
      $viewRewardPoint.css('left', width + 'px');
    }
  }, 3000);
}
viewRewardPoint = () => {
  var clubTier = $('div[data-lion-tier-overview]');
  var top = clubTier.offset().top - 200;
  window.scrollTo({ top: top, behavior: 'smooth' });
}

anchorToRewardSection = () => {
  if (window.location.hash === '#jscAnchrReward') {
    setTimeout(() => {
      viewRewardPoint();
    }, 2000);
  }
}
// end: account page view reward points

// start: pwp cart upsell
updatePWP = () => {
  if(window.location.href.includes('/cart')) {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    })
    .then(response => {
      // Parse the response as JSON
      return response.json();
    })
    .then(data => { // functions call
      togglePWPUpsell(data);
      updatePWPItemPrice(data);
      updateProgressBar(data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

updateProgressBar = (data) => {
  var $pwpUpsellWrapper = $('.jsc-pwp-cart-upsell-wrapper');
  var $progressBar = $($pwpUpsellWrapper).find('.jsc-pwp-progress-bar .jsc-pwp-progress');
  var cartTotal = data.original_total_price;
  var threshold = $pwpUpsellWrapper.data('threshold-amount');
  var progress = (cartTotal / threshold) * 100;
  $progressBar.css('width', progress + '%');

  var promptMessage = $($pwpUpsellWrapper).find('.jsc-pwp-prompt-message');
  var successMessage = $($pwpUpsellWrapper).find('.jsc-pwp-success-message');
  if(progress < 100) {
    promptMessage.show();
    successMessage.hide();
  }
  else {
    promptMessage.hide();
    successMessage.show();
  }
}

togglePWPUpsell = (data) => {
  var $pwpUpsellWrapper;
  if ($(window).width() > 480) {
    $pwpUpsellWrapper = $('.jsc-pwp-cart-upsell-wrapper:not(.jsc-pwp-mobile)');
  }
  else {
    $pwpUpsellWrapper = $('.jsc-pwp-cart-upsell-wrapper.jsc-pwp-mobile');
  }

  // var $pwpUpsellWrapper = $('.jsc-pwp-cart-upsell-wrapper');
  var pwpVid = parseInt($pwpUpsellWrapper.data('pwp-vid'));
  var threshold = $pwpUpsellWrapper.data('threshold-amount');
  var cartTotal = data.original_total_price;
  var cartItems = data.items;

  if(cartTotal <= 0) { // cart is empty
    $pwpUpsellWrapper.hide();
  }
  else {
    // check if PWP in cart
    var pwpInCart = cartItems.some(function(obj) {
        return obj.id === pwpVid;
    });
    
    if(cartTotal >= threshold && pwpInCart) {
      $pwpUpsellWrapper.hide();
    }
    else {
      $pwpUpsellWrapper.show();
    }
  }
}

updatePWPItemPrice = (data) => {
  var $pwpUpsellWrapper;
  var $pwpItemPrice;
  if ($(window).width() > 480) {
    $pwpUpsellWrapper = $('.jsc-pwp-cart-upsell-wrapper:not(.jsc-pwp-mobile)');
    $pwpItemPrice = $($pwpUpsellWrapper).find('.jsc-pwp-item-price:not(.jsc-pwp-mobile)');
  }
  else {
    $pwpUpsellWrapper = $('.jsc-pwp-cart-upsell-wrapper.jsc-pwp-mobile');
    $pwpItemPrice = $($pwpUpsellWrapper).find('.jsc-pwp-item-price.jsc-pwp-mobile');
  }

  var pwpProdPrice = $pwpUpsellWrapper.data('pwp-price');
  var discountPercent = 100 - $pwpUpsellWrapper.data('pwp-discount');
  var threshold = $pwpUpsellWrapper.data('threshold-amount');
  var cartTotal = data.original_total_price;
  var isoCode = data.currency;
  var currencySymbol = $pwpUpsellWrapper.data('currency-symbol');
  var lastPrice = (pwpProdPrice * discountPercent) / 100;
  var lastPriceText = currencySymbol + (lastPrice / 100);
  if(isoCode !== 'SGD') {
    lastPrice = lastPriceText + ' ' + isoCode;
  }

  if(cartTotal >= threshold) { // threshold hit, display discounted price
    $($pwpItemPrice).find('.jsc-pwp-item-last-price').text(lastPriceText);
    $($pwpItemPrice).find('.jsc-pwp-item-ori-price').css('text-decoration', 'line-through');
  }
  else {
    $($pwpItemPrice).find('.jsc-pwp-item-last-price').text('');
    $($pwpItemPrice).find('.jsc-pwp-item-ori-price').css('text-decoration', 'none');
  }
  
  // console.log('run update pwp price', data);
}
// end: pwp cart upsell

// start: mobile product grid image slider
initProductGridImageSlider = () => {
  if($(window).width() < 1025) {
    var $productGrid = $('#CollectionLoop .grid-item');
    $($productGrid).each(function(index, grid) {
      var $productLinkImage = $(grid).find('.product-item__image .product-link');
      var $secondImg = $($productLinkImage).find('.product-item__bg__under');

      $($productLinkImage).flickity();
      $($productLinkImage).flickity('destroy');
      $secondImg.hide();
      setTimeout(() => {
        $secondImg.show();
        $($productLinkImage).flickity({
          pageDots: true,
          draggable: true,
          contain: true,
          cellAlign: "left",
          prevNextButtons: false
        });
      }, 400);
    });
  }
}
// end: mobile product grid image slider

// start: open external link in new tab
openLinkNewTab = () => {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}
// end: open external link in new tab

// start: pdp icon accordion
toggleIconContent = (e) => {
  var $content = $(e).find('.product__icon__content');
  if($content.length > 0) {
    $(e).toggleClass('active');
  }
}
// end: pdp icon accordion

// start: pdp back to top arrow dynamic pos
updateArrowPos = () => {
  if($(window).width() > 480) {
    var stickyATCHeight = $('#cart-bar').height();
    var $scrollTopBtn = $('.btn--scroll-top');
    $scrollTopBtn.css('bottom', (stickyATCHeight + 10) + 'px');
  }
}
// end: pdp back to top arrow dynamic pos

// start: extension upsell ATC
atcExtension = (e) => {
  var vid = parseInt($(e).attr('id'));
  cartJSAddQuery(vid, 1, {});
}
// end: extension upsell ATC

// start: update PDP label based on variant
updatePdpLabel = (e) => {
  if ($(e).closest('.section-featured-product[product-handle="giftcard"]').length) return;

  var isCustomLabel = false;
  var isSellingFast = false;
  var isSoldOut = false;
  var isShowLabel = false;

  var onlineInventory = parseInt($(e).siblings('input').attr('data-online-inventory'));
  var isAvailable = $(e).siblings('input').attr('data-available-online');
  var $pdpLabel = $('.product__page .product__slides .badge-box');
  var isGldSmith = $($pdpLabel).attr('data-is-gld-smith');

  if($pdpLabel.hasClass('jsc-custom-label')) {
    isCustomLabel = true;
  }
  
  if (onlineInventory > 0 && onlineInventory <= 10) {
    isSellingFast = true;
  }

  if(isAvailable == 'false') {
    isSoldOut = true;
  }

  if(!isCustomLabel) {
    if(isAvailable == 'true') {
      if(isSellingFast) {
        if(isGldSmith == 'false') {
          $pdpLabel.text('Selling Fast');
          $pdpLabel.addClass('jsc-label-selling-fast');
          isShowLabel = true;
        }
      }
      else {
        isShowLabel = false;
      }
    }
    else {
        $pdpLabel.text('Sold Out');
        $pdpLabel.removeClass('jsc-label-selling-fast');
        isShowLabel = true; 
    }
  }
  else {
    isShowLabel = true;
  }

  if ($('#gift-card').length > 0) {
    isShowLabel = false;
  }

  if(isShowLabel) {
    $pdpLabel.removeClass('jsc-hidden-label');
  }
  else {
    $pdpLabel.addClass('jsc-hidden-label');
  }
  setupVariantOption($(e).siblings('input').val());
}
// end: update PDP label based on variant

// start: complete the look drawer
openUpsellDrawer = () => {
  var $drawerOverlay = $('.jsc-complete-the-look-drawer-overlay');
  var $drawer = $('.jsc-complete-the-look-drawer');
  var $chat = $('#chat-button');

  $drawerOverlay.addClass('active');
  $drawer.addClass('active');
  $chat.css('visibility', 'hidden');
}

closeUpsellDrawer = () => {
  var $drawerOverlay = $('.jsc-complete-the-look-drawer-overlay');
  var $drawer = $('.jsc-complete-the-look-drawer');
  var $chat = $('#chat-button');

  $drawerOverlay.removeClass('active');
  $drawer.removeClass('active');
  $chat.css('visibility', 'visible');
}

toggleGridCheckbox = (e) => {
  var $customCheckbox;
  if($(e).hasClass('jsc-drawer-grid-checkbox')) {
    $customCheckbox = $(e);
  }
  else {
    $customCheckbox = $(e).siblings('.jsc-drawer-grid-checkbox');
  }
  $customCheckbox.toggleClass('active');
}

updateUpsellItem = () => {
  var isItemAdded = false;

  // clear complete the look list
  $('.jsc-complete-the-look-wrapper .jsc-complete-the-look-items-container').find('.jsc-complete-the-look-item:not(.jsc-item-template)').remove();

  // add item to complete the look list
  var $gridItems = $('.jsc-complete-the-look-drawer .jsc-drawer-grid .grid-item');
  $gridItems.each(function() {
    var $checkbox = $(this).find('.jsc-drawer-grid-checkbox');
    if($checkbox.hasClass('active')) {
      isItemAdded = true
      var productTitle = $(this).find('.product-item__title').text();
      var productSubtitle = $(this).find('.jsc-product-item__subtitle').text();
      var productImg = $(this).find('.product-item__image').attr('data-img-url');
      var variantId = $(this).attr('data-vid');

      var $itemContainer = $('.jsc-complete-the-look-wrapper .jsc-complete-the-look-items-container');
      var $newItem = $($itemContainer).find('.jsc-complete-the-look-item.jsc-item-template').clone().removeAttr('style').removeClass('jsc-item-template');
      $($newItem).find('.jsc-complete-the-look-item-img img').attr('src', productImg);
      $($newItem).find('.jsc-complete-the-look-item-info .jsc-complete-the-look-item-title').text(productTitle);
      $($newItem).find('.jsc-complete-the-look-item-info .jsc-complete-the-look-item-subtitle').text(productSubtitle);
      $($newItem).attr('data-vid', variantId);
      $itemContainer.append($newItem);
    }
  });

  // update the complete the look button text
  if (isItemAdded === true) {
    $('.jsc-complete-the-look-wrapper').find('.jsc-btn-toggle-upsell-drawer').text('Edit Items');
  }
  else {
    $('.jsc-complete-the-look-wrapper').find('.jsc-btn-toggle-upsell-drawer').text('Add Items');
  }

  // close the upsell drawer
  closeUpsellDrawer();
}

removeUpsellItem = (e) => {
  var $item = $(e).parents('.jsc-complete-the-look-item');
  var itemVid = $($item).attr('data-vid');
  var $otherItems = $($item).siblings('.jsc-complete-the-look-item:not(.jsc-item-template)');

  $item.remove();

  // revert the text to add when the last item in list is removed
  if($otherItems.length === 0) {
    $('.jsc-complete-the-look-wrapper').find('.jsc-btn-toggle-upsell-drawer').text('Add Items');
  }

  // update drawer grid checkbox
  var $gridItems = $('.jsc-complete-the-look-drawer .jsc-drawer-grid .grid-item');
  var $checkbox = $gridItems.filter('[data-vid="' + itemVid + '"]').find('.jsc-drawer-grid-checkbox');
  $checkbox.removeClass('active');
}

completeTheLookAtc = (e) => {
  var $completeTheLookWrapper = $('.jsc-complete-the-look-wrapper');
  var $itemList = $($completeTheLookWrapper).find('.jsc-complete-the-look-item:not(.jsc-item-template)');
  if($itemList.length > 0) {
    $(e).prop('disabled', true);
    var atcItems = [];
    var seconds = new Date().getTime() / 1000;

    // main item
    var mainItem = {};
    var mainId = parseInt($($completeTheLookWrapper).parents('.form__width').find('input[name="id"]').val());
    var mainQty = parseInt($(e).siblings('.select-popout').find('span[data-popout-toggle-text]').text());   
    var bundleID = mainId + '-' + seconds; 
    mainItem['id'] = mainId;
    mainItem['quantity'] = mainQty;
    mainItem['properties'] = mainItem['properties'] || {};

    var $giftWrapCtl = $('.product__page').find('.jsc-gift-wrap-input');
    var currentGiftWrapCtl = $giftWrapCtl.length > 0 ? $giftWrapCtl.val() : 'No Gift Message';

    // message card
    var messageCardItem = getMessageCardItem(bundleID);
    if (messageCardItem != undefined) {
      if (currentGiftWrapCtl == 'Include Message Card with Note') {
        var $giftMessageInput = $giftWrapCtl.parent().siblings('.jsc_personalise_gift_msg');
        var giftMessage = $giftMessageInput.find('#complimentary-gift-message').val();
        mainItem['properties']['Gift Message'] = giftMessage;
      }
      else if (currentGiftWrapCtl == 'Include Blank Message Card') {
        mainItem['properties']['Include Blank Message Card'] = 'Yes';
      }

      mainItem['properties']['_BundleID'] = bundleID;
      atcItems.push(messageCardItem);
    }
    else if (isExtraPackagingActive()) {
      mainItem['properties']['_BundleID'] = bundleID;
    }

    atcItems.push(mainItem);

    appendExtraPackagingToCartItems(atcItems, bundleID, mainQty);

    // complete the look items
    $itemList.each(function() {
      var item = {}
      var vid = parseInt($(this).attr('data-vid'));
      item['id'] = vid;
      item['quantity'] = 1;
      item['properties'] = {};
      atcItems.push(item);
    });

    cartJSEvent();
    CartJS.addItems(atcItems,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
          },
          success: function(cart) {
            removeLeftoverMessageCard();
            getThis.getCart();
            $('.cart__checkout').removeAttr('disabled');
            $('.jsc-loader-overlay').hide();
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        $('.cart__checkout').removeAttr('disabled');
        $('.jsc-loader-overlay').hide();
      }
    });

    setTimeout(function(){
      $(e).prop('disabled', false);
    },1000);
  }
}
// end: complete the look drawer

// start: addon upsell drawer
// Move drawer elements to body level to ensure proper z-index stacking
$(document).ready(function() {
  var $drawerOverlay = $('.jsc-addon-upsell-drawer-overlay');
  var $drawer = $('.jsc-addon-upsell-drawer');
  
  if ($drawerOverlay.length && $drawer.length) {
    // Move to body to escape parent stacking context
    $drawerOverlay.appendTo('body');
    $drawer.appendTo('body');
  }

  // Listen for main product add to cart event
  document.addEventListener('theme:product:add', function(event) {
    console.log("theme:product:add: ", window.addonUpsellSelectedItems);
    if (window.addonUpsellSelectedItems && window.addonUpsellSelectedItems.length > 0) {
      $('.jsc-loader-overlay').show();
      // Get main product variant ID from the form
      var mainId = parseInt($('.product__page').find('input[name="id"]').val());
      var qtyValue = parseInt($('.product__page').find('.select-popout').find('span[data-popout-toggle-text]').text());
      var mainQty = isNaN(qtyValue) ? 1 : qtyValue;

      console.log("mainId: ", mainId, "qtyValue: ", qtyValue, "mainQty: ", mainQty);

      // Add addon upsell items after a short delay
      setTimeout(function() {
        addAddonUpsellItemsToCart(mainId, window.addonUpsellSelectedItems);
        $('.jsc-loader-overlay').hide();
      }, 500);
    }
  });
});

openAddonUpsellDrawer = () => {
  var $drawerOverlay = $('.jsc-addon-upsell-drawer-overlay');
  var $drawer = $('.jsc-addon-upsell-drawer');
  var $chat = $('#chat-button');
  var $loyalty = $('#loyaltylion');

  $drawerOverlay.addClass('active');
  $drawer.addClass('active');
  
  // Hide chat button
  if ($chat.length > 0) {
    $chat[0].style.setProperty('display', 'none', 'important');
  }
  
  // Hide loyalty widget
  if ($loyalty.length > 0) {
    $loyalty[0].style.setProperty('display', 'none', 'important');
  }
  
  // Update banner button text based on selected items
  updateAddonUpsellSelectionSummary();
  
  // Use theme's scroll lock
  document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
}

closeAddonUpsellDrawer = () => {
  var $drawerOverlay = $('.jsc-addon-upsell-drawer-overlay');
  var $drawer = $('.jsc-addon-upsell-drawer');
  var $chat = $('#chat-button');
  var $loyalty = $('#loyaltylion');

  $drawerOverlay.removeClass('active');
  $drawer.removeClass('active');
  
  // Show chat button
  if ($chat.length > 0) {
    $chat[0].style.setProperty('display', 'block', 'important');
  }
  
  // Show loyalty widget
  if ($loyalty.length > 0) {
    $loyalty[0].style.setProperty('display', 'block', 'important');
  }
  
  // Use theme's scroll unlock
  document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
}

// Close addon upsell drawer on escape key
document.addEventListener('keyup', function(evt) {
  if (evt.key === 'Escape' || evt.code === 'Escape') {
    var $drawer = $('.jsc-addon-upsell-drawer');
    if ($drawer.hasClass('active')) {
      closeAddonUpsellDrawer();
    }
  }
});

// Switch tabs in addon upsell drawer
switchAddonUpsellTab = (btn) => {
  var tabIndex = $(btn).attr('data-tab-index');
  var $drawer = $(btn).closest('.jsc-addon-upsell-drawer');
  var $tabContent = $drawer.find(`.jsc-addon-upsell-drawer-tab-content[data-tab-content-index="${tabIndex}"]`);

  // Update active tab button
  $(btn).siblings('.jsc-addon-upsell-drawer-tab').removeClass('active');
  $(btn).addClass('active');

  // Update active tab content
  $tabContent.siblings('.jsc-addon-upsell-drawer-tab-content').removeClass('active');
  $tabContent.addClass('active');

  // Update active tab filter
  var $tabFilter = $drawer.find(`.jsc-addon-upsell-metal-finish-filter[data-tab-filter-index="${tabIndex}"]`);
  $tabFilter.siblings('.jsc-addon-upsell-metal-finish-filter').removeClass('active');
  $tabFilter.addClass('active');
}

// Filter addon upsell products by metal finish
filterAddonUpsellByMetalFinish = (btn, metalFinish, tabIndex) => {
  var $btn = $(btn);
  var $drawer = $btn.closest('.jsc-addon-upsell-drawer');
  var $tabContent = $drawer.find(`.jsc-addon-upsell-drawer-tab-content[data-tab-content-index="${tabIndex}"]`);
  var $gridItems = $tabContent.find('.jsc-addon-upsell-grid-item');
  var $filterContainer = $btn.closest('.jsc-addon-upsell-metal-finish-filter');
  var $filterItems = $filterContainer.find('.jsc-addon-upsell-metal-finish-filter-item');

  // Normalize metal finish for comparison (handleize)
  var normalizeMetalFinish = function(value) {
    if (!value) return '';
    return value.toString().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };

  var normalizedFilterFinish = normalizeMetalFinish(metalFinish);

  // Get filter title element
  var $filterTitle = $filterContainer.find('.jsc-addon-upsell-metal-finish-filter-title');
  var $filterLabel = $btn.find('.jsc-addon-upsell-metal-finish-filter-label');
  var activeFilterLabel = $filterLabel.length > 0 ? $filterLabel.data('metal-finish-label') : metalFinish;

  // Toggle active state
  if ($btn.hasClass('active')) {
    // Show all products - no filter applied
    $btn.removeClass('active');
    $gridItems.show();

    // Hide filter title
    if ($filterTitle.length > 0) {
      $filterTitle.addClass('visually-hidden');
      $filterTitle.text('Material:');
    }
  } else {
    // Filter by metal finish - filter applied
    $filterItems.removeClass('active');
    $btn.addClass('active');

    // Show and update filter title
    if ($filterTitle.length > 0) {
      $filterTitle.removeClass('visually-hidden');
      $filterTitle.text('Material: ' + activeFilterLabel);
    }

    $gridItems.each(function() {
      var $item = $(this);
      var itemMetalFinish = $item.attr('data-metal-finish');

      // Handle comma-separated values or handleized string
      var shouldShow = false;
      if (itemMetalFinish) {
        // The data-metal-finish attribute may contain comma-separated handleized values
        // or a single handleized value
        var metalFinishArray = itemMetalFinish.split(',').map(function(val) {
          return normalizeMetalFinish(val.trim());
        });

        // Check if any of the product's metal finishes match the filter
        shouldShow = metalFinishArray.indexOf(normalizedFilterFinish) !== -1;
      }

      if (shouldShow) {
        $item.show();
      } else {
        $item.hide();
      }
    });
  }
  
  // Re-calculate sticky positions after filter change
  initAddonUpsellTabsStickyTop();
}

// Add addon upsell item - shows quantity selector (no cart update)
addAddonUpsellItem = (btn) => {
  var $btn = $(btn);
  var $gridItem = $btn.closest('.jsc-addon-upsell-grid-item');
  var $qtySelector = $gridItem.find('.jsc-addon-upsell-qty-selector');

  // Hide add button, show quantity selector
  $btn.hide();
  $qtySelector.css('display', 'flex');
}

// Update addon upsell quantity (no cart update)
updateAddonUpsellQty = (btn, action) => {
  var $btn = $(btn);
  var $qtySelector = $btn.closest('.jsc-addon-upsell-qty-selector');
  var $qtyValue = $qtySelector.find('.jsc-addon-upsell-qty-value');
  var $gridItem = $btn.closest('.jsc-addon-upsell-grid-item');
  var $addBtn = $gridItem.find('.jsc-addon-upsell-add-btn');
  var currentQty = parseInt($qtyValue.text());
  var newQty = currentQty;

  if (action === 'increase') {
    newQty = currentQty + 1;
  } else if (action === 'decrease') {
    newQty = currentQty - 1;
  }

  // If quantity becomes 0, hide quantity selector and show add button again
  if (newQty <= 0) {
    newQty = 0;
    $qtySelector.hide();
    $addBtn.show();
    $qtyValue.text(1); // Reset to 1 for next time
    // Update selection summary to remove this item
    updateAddonUpsellSelectionSummary();
    return;
  }

  // Update quantity display
  $qtyValue.text(newQty);
  
  // Update selection summary if visible
  updateAddonUpsellSelectionSummary();
}

// Get all selected addon upsell items
getSelectedAddonUpsellItems = () => {
  var selectedItems = [];
  var $drawer = $('.jsc-addon-upsell-drawer');
  // Check all grid items in all tabs, not just visible ones
  var $gridItems = $drawer.find('.jsc-addon-upsell-grid-item');
  
  $gridItems.each(function() {
    var $item = $(this);
    var $qtySelector = $item.find('.jsc-addon-upsell-qty-selector');

    // Check if quantity selector is visible (item is selected)
    if ($qtySelector.css('display') !== 'none') {
      var $qtyValue = $qtySelector.find('.jsc-addon-upsell-qty-value');
      var quantity = parseInt($qtyValue.text()) || 0;

      // Only include items with quantity > 0
      // Items with quantity 0 should be removed from summary
      if (quantity > 0) {
        var itemData = {
          productId: $item.attr('data-product-id'),
          variantId: $item.attr('data-variant-id'),
          productTitle: $item.attr('data-product-title'),
          productPrice: $item.attr('data-product-price'),
          productImage: $item.attr('data-product-image'),
          quantity: quantity
        };
        selectedItems.push(itemData);
      }
    }
  });
  
  return selectedItems;
}

// Update selection summary display
updateAddonUpsellSelectionSummary = () => {
  var selectedItems = getSelectedAddonUpsellItems();
  var $summary = $('.jsc-addon-upsell-selection-summary');
  var $summaryItems = $summary.find('.jsc-addon-upsell-selection-summary-items');
  var $confirmBtn = $('.jsc-addon-upsell-confirm-btn');
  var $bannerBtn = $('.jsc-drawer-addon-upsell-pdp-banner-add-btn');
  
  // Update window.addonUpsellSelectedItems to match current selection
  window.addonUpsellSelectedItems = selectedItems;
  
  if (selectedItems.length > 0) {
    $summary.show();
    
    // Clear existing items
    $summaryItems.empty();
    
    // Add each selected item to summary
    selectedItems.forEach(function(item) {
      var $summaryItem = $('<div class="jsc-addon-upsell-selection-summary-item">');
      $summaryItem.attr('data-variant-id', item.variantId);
      $summaryItem.append('<div class="jsc-addon-upsell-selection-summary-item-image"><img src="' + item.productImage + '" alt="' + item.productTitle + '"></div>');
      $summaryItem.append('<div class="jsc-addon-upsell-selection-summary-item-details"><div class="jsc-addon-upsell-selection-summary-item-title">' + item.productTitle + '</div><div class="jsc-addon-upsell-selection-summary-item-price">' + item.productPrice + '</div></div>');
      $summaryItem.append('<div class="jsc-addon-upsell-selection-summary-item-qty">Qty: ' + item.quantity + '</div>');
      
      // Add remove button
      var $removeBtn = $('<button type="button" class="jsc-addon-upsell-selection-summary-item-remove" onclick="removeAddonUpsellItemFromSummary(this);" aria-label="Remove ' + item.productTitle + '">');
      $removeBtn.html('<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      $summaryItem.append($removeBtn);
      
      $summaryItems.append($summaryItem);
    });
    
    $confirmBtn.prop('disabled', false);
    
    // Update banner button text to "ADD MORE"
    if ($bannerBtn.length > 0) {
      $bannerBtn.text('ADD MORE');
      $bannerBtn.attr("data-action", "add-more");
    }
  } else {
    $summary.hide();
    $confirmBtn.prop('disabled', true);
    
    // Update banner button text back to "ADD"
    if ($bannerBtn.length > 0) {
      $bannerBtn.text('ADD');
      $bannerBtn.attr("data-action", "add");
    }
  }
}

// Confirm addon upsell selection - shows summary and stores for cart
confirmAddonUpsellSelection = () => {
  var selectedItems = getSelectedAddonUpsellItems();
  
  if (selectedItems.length === 0) {
    return;
  }
  
  // Store selected items globally for cart integration
  window.addonUpsellSelectedItems = selectedItems;
  
  // Close the drawer
  closeAddonUpsellDrawer();
  
  // Show confirmation message (optional)
  console.log('Selected items confirmed:', selectedItems);
}

// Add addon upsell items to cart when main product is added
addAddonUpsellItemsToCart = (mainItemId, addonItems) => {
  if (!addonItems || addonItems.length === 0) {
    return;
  }

  var items = [];
  var seconds = new Date().getTime() / 1000;
  // var bundleID = mainItemId + '-' + seconds;

  // Add each selected upsell item
  addonItems.forEach(function(item) {
    var cartItem = {
      'id': parseInt(item.variantId),
      'quantity': item.quantity,
      'properties': {
        // '_BundleID': bundleID,
        '_AddonUpsell': 'Yes'
      }
    };
    items.push(cartItem);
  });
  
  if (items.length > 0) {
    cartJSEvent();
    CartJS.addItems(items, {
      "success": function(data, textStatus, jqXHR) {
        // Follow the same pattern as bundleAddonAtc and completeTheLookAtc
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            removeLeftoverMessageCard();
            // Refresh cart drawer if available
            if (typeof getThis !== 'undefined' && getThis && typeof getThis.getCart === 'function') {
              getThis.getCart();
            }
            $('.cart__checkout').removeAttr('disabled');
            $('.jsc-loader-overlay').hide();

            // Reset all quantity selectors after successful add to cart
            var $drawer = $('.jsc-addon-upsell-drawer');
            var $gridItems = $drawer.find('.jsc-addon-upsell-grid-item');

            $gridItems.each(function() {
              var $item = $(this);
              var $qtySelector = $item.find('.jsc-addon-upsell-qty-selector');
              var $qtyValue = $qtySelector.find('.jsc-addon-upsell-qty-value');
              var $addBtn = $item.find('.jsc-addon-upsell-add-btn');

              // Reset quantity value to 1
              if ($qtyValue.length > 0) {
                $qtyValue.text('1');
              }

              // Hide quantity selector and show add button
              if ($qtySelector.length > 0) {
                $qtySelector.css('display', 'none');
              }
              if ($addBtn.length > 0) {
                $addBtn.show();
              }
            });

            // Update summary to reflect cleared items (will be empty since all selectors are hidden)
            updateAddonUpsellSelectionSummary();
          }
        });
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.error('Error adding addon upsell items to cart:', errorThrown);
        $('.cart__checkout').removeAttr('disabled');
        $('.jsc-loader-overlay').hide();
      }
    });
  }
}

// Note: We're using the theme:product:add event listener instead of hooking into bundleAddonAtc
// This is defined in the $(function(){}) block at the top of the file

// Update summary when quantity changes
var originalUpdateAddonUpsellQty = updateAddonUpsellQty;
updateAddonUpsellQty = function(btn, action) {
  if (originalUpdateAddonUpsellQty) {
    originalUpdateAddonUpsellQty(btn, action);
  }
  updateAddonUpsellSelectionSummary();
}

// Update summary when item is added
var originalAddAddonUpsellItem = addAddonUpsellItem;
addAddonUpsellItem = function(btn) {
  if (originalAddAddonUpsellItem) {
    originalAddAddonUpsellItem(btn);
  }
  updateAddonUpsellSelectionSummary();
}

// Remove addon upsell item from summary
removeAddonUpsellItemFromSummary = (btn) => {
  var $btn = $(btn);
  var $summaryItem = $btn.closest('.jsc-addon-upsell-selection-summary-item');
  var variantId = $summaryItem.attr('data-variant-id');
  
  if (!variantId) {
    return;
  }
  
  // Find the corresponding grid item in the drawer
  var $drawer = $('.jsc-addon-upsell-drawer');
  var $gridItem = $drawer.find('.jsc-addon-upsell-grid-item[data-variant-id="' + variantId + '"]');
  
  if ($gridItem.length > 0) {
    var $qtySelector = $gridItem.find('.jsc-addon-upsell-qty-selector');
    var $qtyValue = $qtySelector.find('.jsc-addon-upsell-qty-value');
    var $addBtn = $gridItem.find('.jsc-addon-upsell-add-btn');
    
    // Hide quantity selector and show add button
    $qtySelector.css('display', 'none');
    $addBtn.show();
    
    // Reset quantity to 1
    if ($qtyValue.length > 0) {
      $qtyValue.text('1');
    }
  }
  
  // Update selection summary (will automatically remove this item since qty selector is now hidden)
  updateAddonUpsellSelectionSummary();
}
// end: addon upsell drawer

// start: addon upsell info drawer
// Move info drawer elements to body level to ensure proper z-index stacking
// Only keep one instance if multiple exist
$(document).ready(function() {
  var $infoDrawerOverlays = $('.jsc-addon-upsell-info-drawer-overlay');
  var $infoDrawers = $('.jsc-addon-upsell-info-drawer');

  if ($infoDrawerOverlays.length > 0 && $infoDrawers.length > 0) {
    // Remove duplicates, keep only the first instance
    if ($infoDrawerOverlays.length > 1) {
      $infoDrawerOverlays.slice(1).remove();
    }
    if ($infoDrawers.length > 1) {
      $infoDrawers.slice(1).remove();
    }

    // Move to body to escape parent stacking context
    $('.jsc-addon-upsell-info-drawer-overlay').appendTo('body');
    $('.jsc-addon-upsell-info-drawer').appendTo('body');
  }
});

openAddonUpsellInfoDrawer = (btn) => {
  var $btn = $(btn);
  var $gridItem = $btn.closest('.jsc-addon-upsell-grid-item');
  var productId = $gridItem.attr('data-product-id');
  var $infoData = $gridItem.find('.jsc-addon-upsell-grid-item-info-data[data-product-id="' + productId + '"]');
  var $drawerOverlay = $('.jsc-addon-upsell-info-drawer-overlay');
  var $drawer = $('.jsc-addon-upsell-info-drawer');
  var $drawerBody = $drawer.find('.jsc-addon-upsell-info-drawer-body');
  var $injectedContent = $drawerBody.find('.jsc-addon-upsell-info-drawer-injected-content');
  var $chat = $('#chat-button');

  if ($infoData.length === 0) {
    return;
  }

  // Clone and inject the product info content into the drawer
  var $contentClone = $infoData.clone();
  $contentClone.removeAttr('style').removeClass('jsc-addon-upsell-grid-item-info-data');
  $injectedContent.empty().append($contentClone);

  // Initialize carousel if it exists
  var $carousel = $injectedContent.find('.jsc-addon-upsell-info-carousel');
  if ($carousel.length > 0) {
    // Destroy existing Splide instance if it exists
    if ($carousel[0].splide) {
      $carousel[0].splide.destroy();
    }

    // Wait for DOM to be ready before initializing
    setTimeout(function() {
      // Initialize new Splide instance
      var splide = new Splide($carousel[0], {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '0px',
        pagination: true,
        arrows: true,
        rewind: false,
        drag: 'free',
        snap: true,
        keyboard: 'global',
        waitForTransition: false,
        updateOnMove: true,
        trimSpace: false,
        breakpoints: {
          750: {
            arrows: false,
            pagination: true
          }
        }
      });

      splide.mount();

      // Store reference for cleanup
      $carousel[0].splide = splide;
    }, 50);
  }

  // Open drawer
  $drawerOverlay.addClass('active');
  $drawer.addClass('active');
  if ($chat.length) {
    $chat.css('visibility', 'hidden');
  }

  // Use theme's scroll lock
  document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));

  // Focus management for accessibility
  var $closeBtn = $drawer.find('.jsc-addon-upsell-info-drawer-close-top');
  if ($closeBtn.length) {
    setTimeout(function() {
      $closeBtn.focus();
    }, 100);
  }
}

closeAddonUpsellInfoDrawer = () => {
  var $drawerOverlay = $('.jsc-addon-upsell-info-drawer-overlay');
  var $drawer = $('.jsc-addon-upsell-info-drawer');
  var $injectedContent = $drawer.find('.jsc-addon-upsell-info-drawer-injected-content');
  var $chat = $('#chat-button');

  // Destroy carousel instance if it exists
  var $carousel = $injectedContent.find('.jsc-addon-upsell-info-carousel');
  if ($carousel.length > 0) {
    var carouselEl = $carousel[0];
    if (carouselEl.splide) {
      try {
        carouselEl.splide.destroy();
        carouselEl.splide = null;
      } catch (e) {
        console.warn('Error destroying carousel:', e);
      }
    }
  }

  $drawerOverlay.removeClass('active');
  $drawer.removeClass('active');
  if ($chat.length) {
    $chat.css('visibility', 'visible');
  }

  // Use theme's scroll unlock
  document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));

  // Clear drawer content
  $injectedContent.empty();
}

// Close info drawer on escape key
document.addEventListener('keyup', function(evt) {
  if (evt.key === 'Escape' || evt.code === 'Escape') {
    var $drawer = $('.jsc-addon-upsell-info-drawer');
    if ($drawer.hasClass('active')) {
      closeAddonUpsellInfoDrawer();
    }
  }
});
// end: addon upsell info drawer

// start: re-enable slideshow animation
enableSlideshowAnimation = () => {
  var $slideshow = $('.slideshow__slider');
  if($slideshow.length > 0) {
    var intervalID = setInterval(() => {
      var $firstSlide = $($slideshow).find('.slideshow__slide.no-animation:not(.is-selected)');
      if($firstSlide.length > 0) {
        $firstSlide.removeClass('no-animation');
        clearInterval(intervalID);
      }
    }, 500);
  }
}
// end: re-enable slideshow animation

// start: pdp custom content slider
initTagPageSlider = () => {
  var $slider = $('.brick-section-slider');
  if($slider.length > 0) {
    $slider.flickity({
      cellAlign: 'left',
      draggable: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false
    });

    var $sliderNavContainer = $($slider).siblings('.display-tag-pages__nav-container');
    var $currentPageNum = $($sliderNavContainer).find('.jsc-current-page');
    $slider.on( 'change.flickity', function(event, index) {
      var sliderno = $(this).find('.slider-item').length - 1;
      console.log(sliderno);
      console.log(index);
      if (sliderno == index) {
        $(this).siblings('.display-tag-pages__nav-container').find('.flickity-prev').removeClass('opacityless');
        $(this).siblings('.display-tag-pages__nav-container').find('.flickity-next').addClass('opacityless');
      }else if (index == 0) {
        $(this).siblings('.display-tag-pages__nav-container').find('.flickity-prev').addClass('opacityless');
        $(this).siblings('.display-tag-pages__nav-container').find('.flickity-next').removeClass('opacityless');
      }else {
        $(this).siblings('.display-tag-pages__nav-container').find('.flickity-prev').removeClass('opacityless');
        $(this).siblings('.display-tag-pages__nav-container').find('.flickity-next').removeClass('opacityless');
      }
      $currentPageNum.text(index + 1);
    });
  }
}

tagPageNext = () => {
  var $slider = $('.brick-section-slider');
  $slider.flickity('next');
}

tagPagePrev = () => {
  var $slider = $('.brick-section-slider');
  $slider.flickity('previous');
}
// end: pdp custom content slider

// start: gift message card
updatePdpGiftWrapOption = (evt) => {
  var value = $(evt).val();
  var $giftMessageInput = $(evt).parent().siblings('.jsc_personalise_gift_msg');
  var $pdpAtcBtn = $('.product__block--buttons').find('.jsc-pdp-atc');

  if (value == 'Include Message Card with Note') {
    $giftMessageInput.addClass('active');
    $giftMessageInput.find('#complimentary-gift-message').val('');
    $pdpAtcBtn.prop('disabled', true);
  }
  else if (value == 'Include Blank Message Card') {
    $giftMessageInput.removeClass('active');
    $pdpAtcBtn.prop('disabled', false);
  }
  else {
    $giftMessageInput.removeClass('active');
    $pdpAtcBtn.prop('disabled', false);
  }

  setTimeout(() => {
    var $currentGiftWrap = $(evt).siblings('.jsc-select-gift-wrap').find('.jsc-gift-wrap-opt.is-active');
    var currentGiftWrapVarID = parseInt($currentGiftWrap.find('.select-popout__option').attr('variant-id'));
    $(evt).attr('variant-id', currentGiftWrapVarID);
  }, 500);
}

isExtraPackagingActive = () => {
  var $cfg = $('#jsc-extra-packaging-config');
  return $cfg.length > 0 && $cfg.attr('data-active') === 'true';
};

getExtraPackagingMainProductTitle = () => {
  var $giftWrap = $('.product__page').find('.jsc-gift-wrap-input');
  if ($giftWrap.length > 0) {
    var fromGift = $giftWrap.attr('main-product');
    if (fromGift) {
      return fromGift;
    }
  }
  var $cfg = $('#jsc-extra-packaging-config');
  return $cfg.length ? ($cfg.attr('data-main-title') || '') : '';
};

getExtraPackagingItemForProduct = (variantId, bundleID, mainQty, mainProductTitle) => {
  var vid = typeof variantId === 'string' ? parseInt(variantId, 10) : variantId;
  if (!vid || isNaN(vid)) {
    return;
  }
  return {
    'id': vid,
    'quantity': mainQty,
    'properties': {
      '_BundleID': bundleID,
      '_ExtraPackaging': 'Yes',
      'Item': mainProductTitle
    }
  };
};

getExtraPackagingItem = (bundleID, mainQty, mainProductTitle) => {
  if (!isExtraPackagingActive()) {
    return;
  }
  var $cfg = $('#jsc-extra-packaging-config');
  var vid = parseInt($cfg.attr('data-variant-id'), 10);
  if (!vid || isNaN(vid)) {
    return;
  }
  return getExtraPackagingItemForProduct(vid, bundleID, mainQty, mainProductTitle);
};

appendExtraPackagingToCartItems = (items, bundleID, mainQty) => {
  if (!isExtraPackagingActive()) {
    return;
  }
  var title = getExtraPackagingMainProductTitle();
  var packagingLineItem = getExtraPackagingItem(bundleID, mainQty, title);
  if (packagingLineItem !== undefined && packagingLineItem !== null) {
    items.push(packagingLineItem);
  }
};

extraPackagingAtc = (evt) => {
  var $completeTheLook = $('.jsc-complete-the-look-wrapper').find('.jsc-complete-the-look-item:not(.jsc-item-template)');
  var $addonWrap = $('.jsc-addon__wrap');
  var $activeAddon = $addonWrap.find('[variant-item].active');
  var $compulsoryCharm = $('.jsc-compulsory-charms');
  var $activeCharm = $compulsoryCharm.find('.jsc-compulsory-charms__option.active');
  var $giftWrap = $('.product__page').find('.jsc-gift-wrap-input');

  if ($completeTheLook.length > 0 || $activeAddon.length > 0 || $activeCharm.length > 0) {
    return;
  }
  if (!isExtraPackagingActive()) {
    return;
  }
  if ($giftWrap.length > 0 && $giftWrap.val() != 'No Gift Message') {
    return;
  }

  var $errorContainer = $(evt).parents('.product__submit__buttons').siblings('.product__form__errors');
  var seconds = new Date().getTime() / 1000;

  $(evt).prop('disabled', true);
  var mainId = parseInt($('.product__page').find('input[name="id"]').val(), 10);
  var qtyValue = parseInt($(evt).siblings('.select-popout').find('span[data-popout-toggle-text]').text(), 10);
  var mainQty = isNaN(qtyValue) ? 1 : qtyValue;
  var bundleID = mainId + '-' + seconds;

  var mainItem = {
    'id': mainId,
    'quantity': mainQty,
    'properties': {
      '_BundleID': bundleID
    }
  };

  var items = [];
  items.push(mainItem);
  appendExtraPackagingToCartItems(items, bundleID, mainQty);

  cartJSEvent();
  CartJS.addItems(items,
  {
    'success': function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          removeLeftoverMessageCard();
          getThis.getCart();

          $errorContainer.html('');
          $errorContainer.removeClass('is-visible');

          $('.cart__checkout').removeAttr('disabled');
          $('.jsc-loader-overlay').hide();
        }
      });
    },
    'error': function(jqXHR, textStatus, errorThrown) {
      var errMsg = (jqXHR.responseJSON && jqXHR.responseJSON.description) ? jqXHR.responseJSON.description : '';
      console.log('Error occur !', errMsg);

      $errorContainer.html(`<div class="errors">${errMsg}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`);
      $errorContainer.addClass('is-visible');

      $('.cart__checkout').removeAttr('disabled');
      $('.jsc-loader-overlay').hide();
    }
  });

  setTimeout(function() {
    $(evt).prop('disabled', false);
  }, 1000);
};

getMessageCardItem = (bundleID) => {
  var $giftWrap = $('.product__page').find('.jsc-gift-wrap-input');
  if ($giftWrap.length > 0) {
    var currentGiftWrap = $giftWrap.val();
    var mainProductTitle = $giftWrap.attr('main-product');
    var giftWrapID = parseInt($giftWrap.attr('variant-id'));
    var giftWrapProps = {};

    if (giftWrapID != 0) {
      giftWrapProps['_BundleID'] = bundleID;
      giftWrapProps['_MessageCard'] = 'Yes';
      giftWrapProps['Item'] = mainProductTitle;

      if (currentGiftWrap == 'Include Message Card with Note') {
        var $giftMessageInput = $giftWrap.parent().siblings('.jsc_personalise_gift_msg');
        var giftMessage = $giftMessageInput.find('#complimentary-gift-message').val();
        giftWrapProps['Gift Message'] = giftMessage;
      }

      var messageCardItem = {
        'id': giftWrapID,
        'quantity': 1,
        'properties': giftWrapProps
      };

      return messageCardItem;
    }
  }
}

giftWrapATC = (evt) => {
  var $completeTheLook = $('.jsc-complete-the-look-wrapper').find('.jsc-complete-the-look-item:not(.jsc-item-template)'); // complete the look
  var $addonWrap = $('.jsc-addon__wrap'); // bundle add on
  var $addonWrap = $('.jsc-addon__wrap');
  var $compulsoryCharm = $('.jsc-compulsory-charms');
  var $activeAddon = $addonWrap.find('[variant-item].active');
  var $activeCharm = $compulsoryCharm.find('.jsc-compulsory-charms__option.active');
  
  var $giftWrap = $('.product__page').find('.jsc-gift-wrap-input'); // gift wrap option

  if ($completeTheLook.length <= 0 && $activeAddon.length <=0 && $activeCharm.length <=0 && $giftWrap.length > 0) {
    var currentGiftWrap = $giftWrap.val();
    if (currentGiftWrap != 'No Gift Message') {
      var $errorContainer = $(evt).parents('.product__submit__buttons').siblings('.product__form__errors');
      var seconds = new Date().getTime() / 1000;

      $(evt).prop('disabled', true); // disable ATC button
      var items = [];

      // main items
      var mainId = parseInt($('.product__page').find('input[name="id"]').val());
      var qtyValue = parseInt($(evt).siblings('.select-popout').find('span[data-popout-toggle-text]').text());
      var mainQty = isNaN(qtyValue) ? 1 : qtyValue;
      var bundleID = mainId + '-' + seconds;
      var mainItem = {
        'id': mainId,
        'quantity': mainQty,
        'properties': {
          '_BundleID': bundleID
        }
      };

      if (currentGiftWrap == 'Include Message Card with Note') {
        var $giftMessageInput = $giftWrap.parent().siblings('.jsc_personalise_gift_msg');
        var giftMessage = $giftMessageInput.find('#complimentary-gift-message').val();
        mainItem['properties']['Gift Message'] = giftMessage;
      }
      else if (currentGiftWrap == 'Include Blank Message Card') {
        mainItem['properties']['Include Blank Message Card'] = 'Yes';
      }

      items.push(mainItem);

      // message card
      var messageCardItem = getMessageCardItem(bundleID);
      if (messageCardItem != undefined) {
        items.push(messageCardItem);
      }

      appendExtraPackagingToCartItems(items, bundleID, mainQty);

      cartJSEvent();
      CartJS.addItems(items,
      {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
              console.log('before');
            },
            success: function(cart) {
              removeLeftoverMessageCard();
              getThis.getCart();

              // hide error message
              $errorContainer.html('')
              $errorContainer.removeClass('is-visible');

              $('.cart__checkout').removeAttr('disabled');
              $('.jsc-loader-overlay').hide();
            }
          });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", jqXHR.responseJSON.description);

          // show error message
          $errorContainer.html(`<div class="errors">${jqXHR.responseJSON.description}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`)
          $errorContainer.addClass('is-visible');

          $('.cart__checkout').removeAttr('disabled');
          $('.jsc-loader-overlay').hide();
        }
      });

      setTimeout(function(){
        $(evt).prop('disabled', false);
      },1000);
    }
  }
}

checkGiftMessageInput = (evt) => {
  var giftMessage = $(evt).val();
  var $giftMessageError = $(evt).siblings('.gift-message-error');
  var $pdpAtcBtn = $('.product__block--buttons').find('.jsc-pdp-atc');

  if(giftMessage != '') {
    $pdpAtcBtn.prop('disabled', false);
    $giftMessageError.removeClass('active');
  }
  else {
    $pdpAtcBtn.prop('disabled', true);
    $giftMessageError.addClass('active');
  }
}

showGiftWrapOptions = (evt) => {
  var isExpanded = $(evt).attr('aria-expanded');
  var $optionList = $(evt).siblings('.jsc-gift-wrap-option-list');
  var $cartItem = $(evt).parents('.cart__item');
  var $otherCartItems = $cartItem.siblings('.cart__item');
  var currentOption = $optionList.siblings('.jsc-gift-wrap-input').val();

  $otherCartItems.each(function() {
    $(this).find('.select-popout__toggle').attr('aria-expanded', false);
    $(this).find('.jsc-gift-wrap-option-list').removeClass('show');
    $(this).css('z-index', 0);
  });

  if (isExpanded == 'true') {
    $(evt).attr('aria-expanded', false);
    $optionList.removeClass('show');
    $cartItem.css('z-index', 0);

    if ($cartItem.hasClass('cart__item--no-border') && currentOption != 'Gift Message' && $(window).width() > 480) {
      $cartItem.css('padding-bottom', '15px');
    }
  }
  else {
    $(evt).attr('aria-expanded', true);
    $optionList.addClass('show');
    $cartItem.css('z-index', 1);

    if ($cartItem.hasClass('cart__item--no-border') && currentOption != 'Gift Message' && $(window).width() > 480) {
      $cartItem.css('padding-bottom', '115px');
    }
  }
}

updateGiftWrapItem = (evt) => {
  var value = $(evt).find('.select-popout__option').attr('data-value');
  var $wrapOptions = $(evt).parents('.jsc-gift-wrap-options');
  var $giftMessageInput = $wrapOptions.siblings('.jsc_personalise_gift_msg');
  var $giftMessageInputError = $giftMessageInput.find('.gift-message-error');
  var properties = JSON.parse($wrapOptions.attr('data-properties'));
  var key = $wrapOptions.attr('data-key');
  var qty = parseInt($(evt).parents('.cart__item__content').find('.cart__quantity .cart__quantity-field').val());
  var $toggleBtn = $wrapOptions.find('.select-popout__toggle');
  var $optionList = $toggleBtn.siblings('.jsc-gift-wrap-option-list');
  var $cartItem = $toggleBtn.parents('.cart__item');
  var $cartItemContainer = $cartItem.parents('.cart__items');
  var messageCard = JSON.parse($cartItemContainer.attr('message-card'));
  var mainTitle = $cartItem.attr('product-title');
  var $giftWrapInput = $wrapOptions.find('.jsc-gift-wrap-input');
  var bundleID = ''
  var seconds = new Date().getTime() / 1000;
  var $allCartItems = $cartItem.siblings('.cart__item');
  var messageCardVariant = messageCard.variants.find(variant => variant.title == value);

  // bundle ID
  if (properties['_BundleID']) {
    bundleID = properties['_BundleID'];
  }
  else {
    var mainID = $cartItem.attr('variant-id');
    bundleID = mainID + '-' + seconds;
  }

  $giftWrapInput.val(value);
  if (value == 'Include Message Card with Note') {
    $giftMessageInput.addClass('active');
    $giftMessageInputError.addClass('active');
    $toggleBtn.attr('aria-expanded', false);
    $optionList.removeClass('show');
    $cartItem.css('z-index', 0);

    if ($cartItem.hasClass('cart__item--no-border') && $(window).width() > 480) {
      $cartItem.css('padding-bottom', '15px');
    }

    $(evt).parent().siblings('.select-popout__toggle').find('span').text(value);
  }
  else if (value == 'Include Blank Message Card') {
    $giftMessageInput.removeClass('active');
    properties['_BundleID'] = bundleID;
    delete properties['Gift Message'];
    delete properties['No Message'];
    properties['Include Blank Message Card'] = 'Yes';

    // remove message card if any
    var giftWrapKeyRemove = '';
    $allCartItems.each(function() {
      if ($(this).attr('is-message-card') != undefined) {
        var itemBundleId = $(this).attr('bundle-id');
        var itemKey = $(this).attr('data-key');

        if (itemBundleId == bundleID) {
          giftWrapKeyRemove = itemKey;
        }
      }
    });

    cartJSUpdateQuery(key, qty, properties);
    if (giftWrapKeyRemove != '') {
      cartJSUpdateQuery(giftWrapKeyRemove, 0, {});
    }
    // add new selected message card
    if (messageCardVariant != undefined) {
      var giftWrapProps = {};
      giftWrapProps['_BundleID'] = bundleID;
      giftWrapProps['_MessageCard'] = 'Yes';
      giftWrapProps['Item'] = mainTitle;
      cartJSAddQuery(messageCardVariant.id, 1, giftWrapProps);
    }
  }
  else {
    $giftMessageInput.removeClass('active');
    delete properties['Gift Message'];
    delete properties['Include Blank Message Card'];
    properties['No Message'] = '';

    // remove message card if any
    var giftWrapKeyRemove = '';
    $allCartItems.each(function() {
      if ($(this).attr('is-message-card') != undefined) {
        var itemBundleId = $(this).attr('bundle-id');
        var itemKey = $(this).attr('data-key');

        if (itemBundleId == bundleID) {
          giftWrapKeyRemove = itemKey;
        }
      }
    });

    cartJSUpdateQuery(key, qty, properties);
    if (giftWrapKeyRemove != '') {
      cartJSUpdateQuery(giftWrapKeyRemove, 0, {});
    }
  }
}

updateGiftMessageProp = (evt) => {
  var giftMessage = $(evt).parents('.jsc_personalise_gift_msg').find('#complimentary-gift-message').val();
  var $wrapOptions = $(evt).parents('.jsc_personalise_gift_msg').siblings('.jsc-gift-wrap-options');
  var properties = JSON.parse($wrapOptions.attr('data-properties'));
  var key = $wrapOptions.attr('data-key');
  var qty = parseInt($(evt).parents('.cart__item__content').find('.cart__quantity .cart__quantity-field').val());
  var $toggleBtn = $wrapOptions.find('.select-popout__toggle');
  var $cartItem = $toggleBtn.parents('.cart__item');
  var $allCartItems = $cartItem.siblings('.cart__item');
  var bundleID = ''
  var seconds = new Date().getTime() / 1000;
  var $cartItemContainer = $cartItem.parents('.cart__items');
  var messageCard = JSON.parse($cartItemContainer.attr('message-card'));
  var messageCardVariant = messageCard.variants.find(variant => variant.title == 'Include Message Card with Note');
  var mainTitle = $cartItem.attr('product-title');
  var toAddBundleId = false;

  // bundle ID
  if (properties['_BundleID']) {
    bundleID = properties['_BundleID'];
  }
  else {
    var mainID = $cartItem.attr('variant-id');
    bundleID = mainID + '-' + seconds;
    toAddBundleId = true;
  }

  delete properties['Include Blank Message Card'];
  delete properties['No Message'];
  properties['Gift Message'] = giftMessage;

  if (toAddBundleId) {
    properties['_BundleID'] = bundleID
  }

  // remove message card if any
  var giftWrapKeyRemove = '';
  $allCartItems.each(function() {
    if ($(this).attr('is-message-card') != undefined) {
      var itemBundleId = $(this).attr('bundle-id');
      var itemKey = $(this).attr('data-key');

      if (itemBundleId == bundleID) {
        giftWrapKeyRemove = itemKey;
      }
    }
  });

  cartJSUpdateQuery(key, qty, properties);
  if (giftWrapKeyRemove != '') {
    cartJSUpdateQuery(giftWrapKeyRemove, 0, {});
  }

  // add new selected message card
  if (messageCardVariant != undefined) {
    var giftWrapProps = {};
    giftWrapProps['_BundleID'] = bundleID;
    giftWrapProps['_MessageCard'] = 'Yes';
    giftWrapProps['Item'] = mainTitle;
    giftWrapProps['Gift Message'] = giftMessage;
    cartJSAddQuery(messageCardVariant.id, 1, giftWrapProps);
  }


}

removeBundle = (evt) => {
  var $cartItem = $(evt).parents('.cart__item');
  var bundleId = $cartItem.attr('bundle-id');
  var key = $cartItem.attr('data-key');
  var $bundleItems = $cartItem.siblings(`.cart__item[bundle-id="${bundleId}"]`);
  var removeList = {};

  if (bundleId != undefined || bundleId != '') {
    $bundleItems.each(function() {
      var itemKey = $(this).attr('data-key');
      removeList[itemKey] = 0;
    });

    removeList[key] = 0;

    if (Object.keys(removeList).length > 0) {
      console.log('remove bundle', removeList);
      cartJSUpdateQuantity(removeList);
    }
  }
}

removeLeftoverMessageCard = () => {
  var $normalCartItems = $('.cart__item:not([is-message-card]):not([is-extra-packaging])');
  var removeList = {};

  $('.cart__item[is-message-card]').each(function() {
    var $item = $(this);
    var messageKey = $item.attr('data-key');
    var messageBundleId = $item.attr('bundle-id');
    var isLeftover = true;

    $normalCartItems.each(function() {
      var bundleId = $(this).attr('bundle-id');
      if (bundleId == messageBundleId) {
        isLeftover = false;
      }
    });

    if (isLeftover) {
      removeList[messageKey] = 0;
    }
  });

  $('.cart__item[is-extra-packaging]').each(function() {
    var $item = $(this);
    var packagingLineKey = $item.attr('data-key');
    var packagingBundleId = $item.attr('bundle-id');
    var isLeftoverPackaging = true;

    $normalCartItems.each(function() {
      var bundleId = $(this).attr('bundle-id');
      if (bundleId == packagingBundleId) {
        isLeftoverPackaging = false;
      }
    });

    if (isLeftoverPackaging) {
      removeList[packagingLineKey] = 0;
    }
  });

  if (Object.keys(removeList).length > 0) {
    console.log('remove leftover bundle companions', removeList);
    cartJSUpdateQuantity(removeList);
  }
}
// end: gift message dropdown

updateBundleItemUI = () => {
  if (window.location.pathname == '/cart') {
    $.getJSON('/cart.js', function(cart) {
      var cartItems = cart.items;
      cartItems.forEach((item, index) => {
        if (item.has_components == true) {
          var lineItemIndex = index + 1;
          var isBlankCard = false;
          var isGiftMessage = false;
          var noMessage = false;
          var $bundleItem = $(`.cart__item[data-item-index="${lineItemIndex}"]`);
          var $giftWrapOptions = $bundleItem.find('.jsc-gift-wrap-options');
          var $giftOptionLabel = $bundleItem.find('.jsc-gift-wrap-options span[data-popout-toggle-text]');
          var $giftMessageInput = $bundleItem.find('.jsc_personalise_gift_msg');
          var charCount = 0;

          $giftWrapOptions.attr('data-key', item.key);
          if (item.properties['Include blank message card'] != undefined) {
            isBlankCard = true;
          }
          if (item.properties['Gift Message'] != undefined) {
            isGiftMessage = true;
            charCount = item.properties['Gift Message'].length;
          }
          if (isBlankCard == false && isGiftMessage == false) {
            noMessage = true;
          }
          
          if (noMessage) {
            $giftOptionLabel.text('No Gift Message');
            $giftMessageInput.removeClass('active');
            $bundleItem.find('.jsc-gift-wrap-opt .select-popout__option[data-value="No Gift Message"]').addClass('is-active');
          }
          else if (isBlankCard) {
            $giftOptionLabel.text('Include Blank Message Card');
            $giftMessageInput.removeClass('active');
            $bundleItem.find('.jsc-gift-wrap-opt .select-popout__option[data-value="Include Blank Message Card"]').addClass('is-active');
          } 
          else if (isGiftMessage) {
            $giftOptionLabel.text('Gift Message');
            $giftMessageInput.addClass('active');
            $bundleItem.find('.jsc-gift-wrap-opt .select-popout__option[data-value="Gift Message"]').addClass('is-active');
            $giftMessageInput.find('#complimentary-gift-message').text(item.properties['Gift Message']);
            $giftMessageInput.find('.count_characters').text(charCount);
          }
        }
      });
    });
  }
}

// start: add ons
toggleAddonTab = (evt) => {
  var index = $(evt).attr('data-index');
  var $tabContent = $(evt).parent().siblings(`.jsc-addon__tab-content-wrap[data-index="${index}"]`);

  $(evt).siblings('.jsc-addon__tab').removeClass('active');
  $(evt).addClass('active');
  $tabContent.siblings('.jsc-addon__tab-content-wrap').removeClass('active');
  $tabContent.addClass('active');
}

addonAtc = (evt) => {
  $(evt).addClass('hide');
  var $qtySelector = $(evt).siblings('.jsc-addon__variant-qty');
  var $qtyInput = $qtySelector.find('.jsc-addon__variant-qty-input');
  var $addon = $(evt).parents('[variant-item]');
  $qtySelector.addClass('active');
  $addon.addClass('active');
  $qtyInput.val(1);
}

decreaseVariantQty = (evt) => {
  var $qtySelector = $(evt).parent();
  var $addBtn = $qtySelector.siblings('.jsc-addon__variant-atc');
  var $qtyInput = $(evt).siblings('.jsc-addon__variant-qty-input');
  var currentQty = parseInt($qtyInput.val());
  var newQty = currentQty - 1;
  var $addon = $(evt).parents('[variant-item]');

  if (newQty <= 0) {
    $qtySelector.removeClass('active');
    $addBtn.removeClass('hide');
    $addon.removeClass('active');
  }
  else {
    $qtyInput.val(newQty);
  }
}

increaseVariantQty = (evt) => {
  var $qtyInput = $(evt).siblings('.jsc-addon__variant-qty-input');
  var currentQty = parseInt($qtyInput.val());
  var newQty = currentQty + 1;
  var maxQty = parseInt($qtyInput.attr('max'));

  if (newQty <= maxQty) {
    $qtyInput.val(newQty);
  }
}

bundleAddonAtc = (evt) => {
  var $addonWrap = $('.jsc-addon__wrap');
  var $compulsoryCharm = $('.jsc-compulsory-charms');
  var $activeAddon = $addonWrap.find('[variant-item].active');
  var $activeCharm = $compulsoryCharm.find('.jsc-compulsory-charms__option.active');
  var $errorContainer = $(evt).parents('.product__submit__buttons').siblings('.product__form__errors');
  
  if ($activeAddon.length > 0 || $activeCharm.length > 0) {
    $(evt).prop('disabled', true);
    var items = [];
    var seconds = new Date().getTime() / 1000;

    // main items
    var mainId = parseInt($('.product__page').find('input[name="id"]').val());
    var qtyValue = parseInt($(evt).siblings('.select-popout').find('span[data-popout-toggle-text]').text());
    var mainQty = isNaN(qtyValue) ? 1 : qtyValue;
    var bundleID = mainId + '-' + seconds;
    var mainItem = {
      'id': mainId,
      'quantity': mainQty,
      'properties': {}
    };

    var $giftWrapAddon = $('.product__page').find('.jsc-gift-wrap-input');
    var currentGiftWrapAddon = $giftWrapAddon.length > 0 ? $giftWrapAddon.val() : 'No Gift Message';

    // message card
    var messageCardItem = getMessageCardItem(bundleID);
    if (messageCardItem != undefined) {
      if (currentGiftWrapAddon == 'Include Message Card with Note') {
        var $giftMessageInput = $giftWrapAddon.parent().siblings('.jsc_personalise_gift_msg');
        var giftMessage = $giftMessageInput.find('#complimentary-gift-message').val();
        mainItem['properties']['Gift Message'] = giftMessage;
      }
      else if (currentGiftWrapAddon == 'Include Blank Message Card') {
        mainItem['properties']['Include Blank Message Card'] = 'Yes';
      }

      mainItem['properties']['_BundleID'] = bundleID;
      items.push(messageCardItem);
    }
    else if (isExtraPackagingActive()) {
      mainItem['properties']['_BundleID'] = bundleID;
    }

    if ($activeCharm.length > 0) {
      mainItem['properties']['_BundleID'] = bundleID;
      mainItem['properties']['_MainItem'] = 'Yes';
    }

    // compulsory charm
    $activeCharm.each(function() {
      var id = parseInt($(this).attr('data-id'));
      var mainTitle = $(this).attr('main-title');
      var charmTitle = $(this).attr('product-title');
      var bundleInfo = charmTitle + ' Part of: ' + mainTitle;
      var charmItem = {
        'id': id,
        'quantity': 1,
        'properties': {
          '_BundleID': bundleID,
          '_CompulsoryCharm': 'Yes',
          '_BundleInfo': bundleInfo
        }
      }
      items.push(charmItem);
      mainItem['properties']['Charm'] = charmTitle;
    });

    items.push(mainItem);

    appendExtraPackagingToCartItems(items, bundleID, mainQty);

    // addon items
    $activeAddon.each(function() {
      var id = parseInt($(this).attr('data-id'));
      var qty = parseInt($(this).find('.jsc-addon__variant-qty-input').val());
      var addonItem = {
        'id': id,
        'quantity': qty,
        'properties': {}
      };
      items.push(addonItem);
    });

    cartJSEvent();
    CartJS.addItems(items,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
          },
          success: function(cart) {
            removeLeftoverMessageCard();
            getThis.getCart();

            // hide error message
            $errorContainer.html('')
            $errorContainer.removeClass('is-visible');

            $('.cart__checkout').removeAttr('disabled');
            $('.jsc-loader-overlay').hide();
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", jqXHR.responseJSON.description);

        // show error message
        $errorContainer.html(`<div class="errors">${jqXHR.responseJSON.description}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`)
        $errorContainer.addClass('is-visible');

        $('.cart__checkout').removeAttr('disabled');
        $('.jsc-loader-overlay').hide();
      }
    });

    setTimeout(function(){
      $(evt).prop('disabled', false);
    },1000);
  }
}

selectCompulsoryCharm = (evt) => {
  var $otherCharms = $(evt).siblings('.jsc-compulsory-charms__option');
  var title = $(evt).attr('product-title');
  var $selectedCharm = $(evt).parents('.jsc-compulsory-charms').find('.jsc-compulsory-charms__title-value');
  $otherCharms.removeClass('active');
  $selectedCharm.text(title);
  $(evt).addClass('active');
}

removeBundle = (evt) => {
  var $cartItem = $(evt).parents('.cart__item');
  var bundleId = $cartItem.attr('bundle-id');
  var key = $cartItem.attr('data-key');
  var $bundleItems = $cartItem.siblings(`.cart__item[bundle-id="${bundleId}"]`);
  var removeList = {};

  if (bundleId != undefined || bundleId != '') {
    $bundleItems.each(function() {
      var itemKey = $(this).attr('data-key');
      removeList[itemKey] = 0;
    });

    removeList[key] = 0;

    if (Object.keys(removeList).length > 0) {
      console.log('remove bundle', removeList);
      cartJSUpdateQuantity(removeList);
    }
  }
}
// end: add ons

checkStoreCredit = () => {
  var $accountSection = $('section.account');
  if ($accountSection.length > 0) {
    var intervalID = setInterval(() => {
      var $creditBtn = $('button[id="Rise-account-page-button"]');
  
      if ($creditBtn.length > 0) {
        $creditBtn.on('click', function(e) {
          var $clickedButton = $(this);
          if ($clickedButton.parents('.sdsds.mobile').length > 0) {
            $creditBtn.each(function() {
              var $this = $(this);
              if ($this.parents('.sdsds.mobile').length == 0) {
                $this.trigger('click');
              }
            });
          }
        });

        clearInterval(intervalID);
      }
    }, 100);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  let intervalId = null;

  function startZoomHideLoop() {
    if (intervalId) return; // prevent multiple intervals

    intervalId = setInterval(function () {
      const zoomOpen = document.querySelector('.pswp--open, .zoom-overlay, .media-modal, .fancybox__container');
      const rewardWidget = document.querySelector('.lion-loyalty-widget');
      const gorgiasIframe = document.querySelector('iframe#chat-button');

      const shouldHide = !!zoomOpen;

      if (shouldHide) {
        if (rewardWidget) rewardWidget.style.visibility = 'hidden';
        if (gorgiasIframe) {
          gorgiasIframe.style.visibility = 'hidden';
          gorgiasIframe.style.opacity = '0';
          gorgiasIframe.style.pointerEvents = 'none';
        }
      } else {
        if (rewardWidget) rewardWidget.style.visibility = 'visible';
        if (gorgiasIframe) {
          gorgiasIframe.style.visibility = 'visible';
          gorgiasIframe.style.opacity = '1';
          gorgiasIframe.style.pointerEvents = 'auto';
        }
      }
    }, 300);
  }

  function stopZoomHideLoop() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  function handleResize() {
    const isMobile = window.innerWidth <= 767;
    if (isMobile) {
      startZoomHideLoop();
    } else {
      stopZoomHideLoop();
    }
  }

  // Initial check
  handleResize();

  // Re-check on viewport resize
  window.addEventListener('resize', function () {
    // Optional: debounce to avoid rapid calls
    clearTimeout(window._resizeTimeout);
    window._resizeTimeout = setTimeout(handleResize, 200);
  });
});




if ($(window).width() < 480 && $section.length > 0) {
  originalTop = $section.offset().top;

  $(window).on('scroll', function () {
    var $header = $('.header-sections');
    var $announcement = $('.shopify-section.page-announcement');
    var $headerWrapper = $('.shopify-section.page-header');

    var hasStuckClass = $headerWrapper.hasClass('js__header__stuck');
    var announcementHeight = hasStuckClass ? $announcement.outerHeight() : 0;
    var headerHeight = $header.outerHeight() + announcementHeight;
    var setHeaderHeight = $headerWrapper.outerHeight();

    var scrollPosition = $(window).scrollTop();
    var headerBottom = scrollPosition + headerHeight;

    if (originalTop <= headerBottom) {
      $section.css({
        position: 'fixed',
        top: setHeaderHeight + 'px',
        left: 0,
        right: 0,
        'z-index': 2300
      });
    } else {
      $section.css({
        position: '',
        top: '',
        left: '',
        right: '',
        'z-index': ''
      });
    }
  });
}

// start: related product slider
initRelatedProductSlider = () => {
  if ($(window).width() > 480) {
    var $slider = $('.jsc-related-product-slider');
    if ($slider.length > 0){
      var options = JSON.parse($slider.attr('data-options'));
      $slider.flickity(options)
    }
  }
}
// end: related product slider

// start: tier gwp
// Global flag to track if tier GWP operations are in progress
window.tierGwpOperationInProgress = false;

// Helper to disable only actual checkout buttons (not View Cart buttons)
disableTierGwpCheckout = () => {
  // Only disable buttons that have name="checkout" (actual checkout buttons)
  $('button[name="checkout"].cart__checkout').attr('disabled', true);
};

// Helper to enable checkout buttons
enableTierGwpCheckout = () => {
  $('button[name="checkout"].cart__checkout').removeAttr('disabled');
  // Also remove disabled from all cart__checkout in case some were disabled
  $('.cart__checkout').removeAttr('disabled');
};

tierGWP = () => {
  var $addTierGwp = $('input[name="jsc-tier-gwp"][jsc-add-gwp]');
  var $updateTierGwp = $('input[name="jsc-tier-gwp"][jsc-update-gwp]');
  var $removeTierGwp = $('input[name="jsc-tier-gwp"][jsc-remove-gwp]');

  var hasAddOps = $addTierGwp.length > 0;
  var hasUpdateOps = $updateTierGwp.length > 0;
  var hasRemoveOps = $removeTierGwp.length > 0;

  // If no operations needed, ensure flag is cleared and exit
  if (!hasAddOps && !hasUpdateOps && !hasRemoveOps) {
    window.tierGwpOperationInProgress = false;
    enableTierGwpCheckout();
    $('.jsc-loader-overlay').hide();
    return;
  }

  console.log('tierGWP: Starting operations - Add:', hasAddOps, 'Update:', hasUpdateOps, 'Remove:', hasRemoveOps);

  // IMMEDIATELY disable checkout button before any operations
  window.tierGwpOperationInProgress = true;
  disableTierGwpCheckout();
  $('.jsc-loader-overlay').show();

  // Track pending operations
  var pendingOps = 0;
  if (hasAddOps) pendingOps++;
  if (hasUpdateOps) pendingOps++;
  if (hasRemoveOps) pendingOps++;

  var completedOps = 0;

  // Function to check if all operations are complete
  var checkAllComplete = function() {
    completedOps++;
    console.log('tierGWP: Operation complete', completedOps, '/', pendingOps);
    if (completedOps >= pendingOps) {
      // All operations complete - refresh cart and re-enable checkout
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(cart) {
          removeLeftoverMessageCard();
          if (typeof getThis !== 'undefined' && getThis && typeof getThis.getCart === 'function') {
            getThis.getCart();
          }
          // Re-enable checkout after a small delay to ensure cart is fully updated
          setTimeout(function() {
            window.tierGwpOperationInProgress = false;
            enableTierGwpCheckout();
            $('.jsc-loader-overlay').hide();
            // Re-initialize checkbox state after cart refresh
            checkTierGwpOptStatus();
            toggleTierGwpProgressBar();
            console.log('tierGWP: All operations complete, checkout enabled');
          }, 500);

          const newCartCount = cart.item_count;
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              bubbles: true,
              detail: {
                cartCount: newCartCount
              }
            })
          );
        },
        error: function() {
          window.tierGwpOperationInProgress = false;
          enableTierGwpCheckout();
          $('.jsc-loader-overlay').hide();
          console.log('tierGWP: Error fetching cart, checkout enabled');
        }
      });
    }
  };

  // Error handler for operations
  var handleError = function(errorThrown) {
    console.log("tierGWP Error: ", errorThrown);
    completedOps++;
    if (completedOps >= pendingOps) {
      window.tierGwpOperationInProgress = false;
      enableTierGwpCheckout();
      $('.jsc-loader-overlay').hide();
    }
  };

  // Process ADD operations
  if (hasAddOps) {
    var $optRemoveTierGwp = sessionStorage.getItem("optTierFreeGift");
    
    // Skip adding Tier GWP if user has opted out
    if ($optRemoveTierGwp != "Remove") {
      var addItems = [];
      $addTierGwp.each(function() {
        var gwpId = parseInt($(this).attr('gwp-id'));
        console.log('tierGWP: Adding GWP with ID:', gwpId);
        var gwpItem = {
          'id': gwpId,
          'quantity': 1,
          'properties': {
            '_GWP Product': 'true',
            '_TierGWP': 'Yes'
          }
        };
        addItems.push(gwpItem);
      });

      CartJS.addItems(addItems, {
        "success": function(data, textStatus, jqXHR) {
          console.log('tierGWP: Add operation successful');
          checkAllComplete();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          handleError(errorThrown);
        }
      });
    } else {
      // User has opted out, skip add operation but still mark as complete
      console.log('tierGWP: Skipping add operation - user opted out');
      checkAllComplete();
    }
  }

  // Process UPDATE operations
  if (hasUpdateOps) {
    var $optRemoveTierGwp = sessionStorage.getItem("optTierFreeGift");
    
    // Skip updating Tier GWP if user has opted out
    if ($optRemoveTierGwp != "Remove") {
      var updateKeyList = {};
      $updateTierGwp.each(function() {
        var gwpKey = $(this).attr('gwp-key');
        updateKeyList[gwpKey] = 1;
      });

      CartJS.updateItemQuantitiesById(updateKeyList, {
        "success": function(data, textStatus, jqXHR) {
          console.log('tierGWP: Update operation successful');
          checkAllComplete();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          handleError(errorThrown);
        }
      });
    } else {
      // User has opted out, skip update operation but still mark as complete
      console.log('tierGWP: Skipping update operation - user opted out');
      checkAllComplete();
    }
  }

  // Process REMOVE operations
  if (hasRemoveOps) {
    var removeKeyList = {};
    $removeTierGwp.each(function() {
      var gwpKey = $(this).attr('gwp-key');
      removeKeyList[gwpKey] = 0;
    });

    CartJS.updateItemQuantitiesById(removeKeyList, {
      "success": function(data, textStatus, jqXHR) {
        console.log('tierGWP: Remove operation successful');
        checkAllComplete();
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        handleError(errorThrown);
      }
    });
  }
}

// tier gwp progress bar
tier_gwp_progressbar = () => {
  var $tier1Min = parseInt($('#__getTierGwpTier1Min').val()) || 0;
  var $tier2Min = parseInt($('#__getTierGwpTier2Min').val()) || 0;
  var $maxQualifier = parseInt($('#__getTierGwpMaxQualifier').val()) || 0;
  var $highestActiveTier = parseInt($('#__getTierGwpHighestActiveTier').val()) || 0;
  var $tier1Msg1 = $('#__getTierGwpTier1Msg1').val() || '';
  var $tier1Msg2 = $('#__getTierGwpTier1Msg2').val() || '';
  var $tier2Msg1 = $('#__getTierGwpTier2Msg1').val() || '';
  var $tier2Msg2 = $('#__getTierGwpTier2Msg2').val() || '';
  var $successMsg = $('#__getTierGwpSuccessMsg').val() || '';
  var $showAmtLeft = $('#__getTierGwpShowAmtLeft').val() === 'true';
  var $currencySymbol = $('#__getTierGwpCurrencySymbol').val() || '';

  if ($maxQualifier === 0) return;

  var $cart_subtotal = 0;

  $.when($.getJSON('/cart.js', function(cart) {
    $cart_subtotal = cart.original_total_price;
  })).then(function(cart) {

    var xcldeArr = {};
    var $excludeTotal = 0;
    var cartItems = cart.items;

    for (var i = 0; i < cartItems.length; i++) {
      var _getHdle = '/products/' + cartItems[i].handle + '.js';
      xcldeArr[_getHdle] = cartItems[i].original_line_price;
    }

    var promises = [];
    $.each(xcldeArr, function(key, valueObj) {
      var promise = jQuery.getJSON(key, function(product) {
        var lowercaseTags = product.tags.map(tag => tag.toLowerCase());
        if (lowercaseTags.includes('mds30off2023') || lowercaseTags.includes('exclude gwp')) {
          $excludeTotal += valueObj;
        }
        // Also exclude GWP products from cart total
        if (product.tags && product.tags.some(tag => tag.toLowerCase().includes('gwp'))) {
          // Check if this item has GWP property
        }
      });
      promises.push(promise);
    });

    // Also check cart items for GWP property
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].properties && cartItems[i].properties['_GWP Product'] === 'true') {
        $excludeTotal += cartItems[i].original_line_price;
      }
    }

    setTimeout(function() {
      var $cartTotAfterExclude = $cart_subtotal - $excludeTotal;
      
      // Determine highest qualified tier
      var $highestQualifiedTier = 0;
      if ($tier2Min > 0 && $cartTotAfterExclude >= $tier2Min) {
        $highestQualifiedTier = 2;
      } else if ($tier1Min > 0 && $cartTotAfterExclude >= $tier1Min) {
        $highestQualifiedTier = 1;
      }

      // Calculate progress percentage based on max qualifier
      var $percentValue = $cartTotAfterExclude / $maxQualifier;
      var $percent = Math.min($percentValue * 100, 100);
      
      // Update progress bar
      $('.__tier_gwp_bar').val($percent);

      // Determine which message to show and calculate left spend
      var $nextTierMin = $tier1Min;
      var $currentMsg1 = $tier1Msg1;
      var $currentMsg2 = $tier1Msg2;
      var $showSuccess = false;

      if ($highestQualifiedTier === 0) {
        // Not qualified for any tier, show tier 1 message
        $nextTierMin = $tier1Min;
        $currentMsg1 = $tier1Msg1;
        $currentMsg2 = $tier1Msg2;
      } else if ($highestQualifiedTier === 1 && $highestActiveTier === 2) {
        // Qualified for tier 1, tier 2 is active, show tier 2 message
        $nextTierMin = $tier2Min;
        $currentMsg1 = $tier2Msg1;
        $currentMsg2 = $tier2Msg2;
      } else if ($highestQualifiedTier >= $highestActiveTier) {
        // Qualified for all active tiers, show success
        $showSuccess = true;
      }

      var $leftSpend = $nextTierMin - $cartTotAfterExclude;

      if ($showSuccess || $leftSpend <= 0) {
        $('.jsc-tier-gwp--message').hide();
        $('.jsc-tier-gwp--success-message').show();
      } else {
        $leftSpend = ($leftSpend / 100).toFixed(2);
        $('.jsc-tier-gwp--success-message').hide();
        
        // Update message content
        var $messageHtml = $currentMsg1;
        if ($showAmtLeft) {
          $messageHtml += ' ' + $currencySymbol + '<span class="jsc-tier-gwp-left-spend">' + $leftSpend + '</span>';
        }
        $messageHtml += ' ' + $currentMsg2;
        
        $('.jsc-tier-gwp--message').html($messageHtml);
        $('.jsc-tier-gwp--message').show();
      }

    }, 1000);
  });
}
// end: tier gwp

// Set dynamic sticky top for addon upsell filter and tab content padding
initAddonUpsellTabsStickyTop = () => {
  var $addonUpsellHeader = $('.jsc-addon-upsell-drawer-header');
  var $addonUpsellTabs = $('.jsc-addon-upsell-drawer-tabs');
  var $addonUpsellFilter = $('.jsc-addon-upsell-metal-finish-filter');
  var $addonUpsellTabContent = $('.jsc-addon-upsell-drawer-tab-content');

  if ($addonUpsellFilter.length) {
    var headerHeight = $addonUpsellHeader.length ? $addonUpsellHeader.outerHeight() : 0;
    var tabsHeight = $addonUpsellTabs.length ? $addonUpsellTabs.outerHeight() : 0;
    var filterStickyTopValue = (headerHeight + tabsHeight - 1) + 'px';
    $addonUpsellFilter.css('top', filterStickyTopValue);
    
    // Set tab content padding-top based on tabs + filter height (not including header since it's outside scrollable area)
    var filterHeight = $addonUpsellFilter.outerHeight() || 0;
    var contentPaddingTop = (filterHeight - 18) + 'px'; 
    
    $addonUpsellTabContent.css('padding-top', contentPaddingTop);
  }
}

//start: show or hide variant button
var setupVariantOption = (optInput) => {
  var $root = $('.template-product').first();
  if (!$root.length) return;

  var $option_size = $root.find('.radio__buttons').first().attr('data-option-size');
  if ($option_size == 2 || $option_size === '2') {
    var checkedOpt1 = $root.find('input[data-index="option1"]:checked').first().val();
    if (checkedOpt1 != null && checkedOpt1 !== '') {
      optInput = checkedOpt1;
    }
  } else if (optInput == null || optInput === '') {
    optInput = $root.find('input[data-index="option1"]:checked').first().val();
  }

  if ($option_size == 1) {
    var inputs = $root.find('input[data-index="option1"]');
  } else {
    var inputs = $root.find('input[data-index="option2"]');
  }

  $root.find('.radio__button').removeClass('jsc-block-swatch-hidden');
  var $var_info = $root.find('.jsc-variant-details.jsc-hidden-variant');
  $var_info.each(function(){
    var $opt_1 = $(this).attr('data-option1');
    var $opt_2 = $(this).attr('data-option2');

    if ($option_size == 1) {
      inputs.each(function () {
        var val = $(this).val();
        var option1 = $root.find('.jsc-variant-details:not(.jsc-hidden-variant)').filter(function () {
          return $(this).attr('data-option1') === val;
        });
        if (option1.length === 0) {
          $(this).parents('.radio__button').addClass('jsc-block-swatch-hidden');
        }
      });
    } else {
      if (optInput == $opt_1) {
        inputs.each(function () {
          var val = $(this).val();
          
          if ($opt_2 == val) {
            $(this).parents('.radio__button').addClass('jsc-block-swatch-hidden');
          }
        });
      }
    }
    
  });
}

var jscResetProductSlideInlineDisplay = () => {
  $('.template-product .product__images .product__slides .product__slide').css('display', '');
};

var jscRefreshBirthstoneVariantImages = () => {
  var $label = $('.template-product input[data-index="option1"]:checked')
    .first()
    .siblings('label')
    .filter(function () {
      var oc = $(this).attr('onclick') || '';
      return oc.indexOf('updateVariantImg') !== -1;
    })
    .first();
  if ($label.length) {
    $label.trigger('click');
  }
};
var controlVariantOption = (e) => {
  var isAutoSelecting = false;

  var getScope = function (source) {
    var $scope = source ? $(source).closest('.form__width') : $();
    if (!$scope.length) {
      $scope = $('input[data-index="option1"]:checked').first().closest('.form__width');
    }
    if (!$scope.length) {
      $scope = $('.template-product .form__width').first();
    }
    return $scope;
  };

  var inputByValue = function ($scope, position, value) {
    return $scope.find('input[data-index="option' + position + '"]').filter(function () {
      return $(this).val() === value;
    }).first();
  };

  var variantMatches = function ($variant, selected, optionCount) {
    for (var i = 1; i <= optionCount; i++) {
      if ($variant.attr('data-option' + i) !== selected[i - 1]) {
        return false;
      }
    }
    return true;
  };

  var syncHiddenVariantState = function (source) {
    if (isAutoSelecting) return;

    var $scope = getScope(source);
    var $allVariants = $scope.find('.jsc-variant-details');
    var $hiddenVariants = $allVariants.filter('.jsc-hidden-variant');
    if (!$scope.length || !$allVariants.length || !$hiddenVariants.length) return;

    var optionCount = 0;
    while ($allVariants.first().attr('data-option' + (optionCount + 1)) !== undefined) {
      optionCount++;
    }
    if (!optionCount) return;

    var selected = [];
    for (var i = 1; i <= optionCount; i++) {
      var $checked = $scope.find('input[data-index="option' + i + '"]:checked').first();
      if (!$checked.length) return;
      selected.push($checked.val());
    }

    // Hide final option values that map to hidden variants for current prefix.
    $scope.find('.radio__button').removeClass('d-none');
    $hiddenVariants.each(function () {
      var $variant = $(this);
      for (var i = 1; i < optionCount; i++) {
        if ($variant.attr('data-option' + i) !== selected[i - 1]) return;
      }
      inputByValue($scope, optionCount, $variant.attr('data-option' + optionCount))
        .closest('.radio__button')
        .addClass('d-none');
    });

    var $selectedVariant = $allVariants.filter(function () {
      return variantMatches($(this), selected, optionCount);
    }).first();
    if (!$selectedVariant.length || !$selectedVariant.hasClass('jsc-hidden-variant')) return;

    var startIndex = $allVariants.index($selectedVariant);
    for (var step = 1; step <= $allVariants.length; step++) {
      var $candidate = $allVariants.eq((startIndex + step) % $allVariants.length);
      if ($candidate.hasClass('jsc-hidden-variant')) continue;

      var candidateInputs = [];
      var valid = true;
      for (var i = 1; i <= optionCount; i++) {
        var $input = inputByValue($scope, i, $candidate.attr('data-option' + i));
        if (!$input.length) {
          valid = false;
          break;
        }
        candidateInputs.push($input);
      }
      if (!valid) continue;

      isAutoSelecting = true;
      candidateInputs.forEach(function ($input) {
        if ($input.is(':checked')) return;
        var inputId = $input.attr('id');
        var $label = $scope.find('label[for="' + inputId + '"]').first();
        if ($label.length) {
          $label.trigger('click');
        } else {
          $input.prop('checked', true).trigger('change');
        }
      });
      setTimeout(function () {
        isAutoSelecting = false;
        jscResetProductSlideInlineDisplay();
        var opt1After = $('.template-product input[data-index="option1"]:checked').first().val();
        if (opt1After != null && opt1After !== '') {
          setupVariantOption(opt1After);
        }
        jscRefreshBirthstoneVariantImages();
      }, 50);
      return;
    }
  };

  setTimeout(function () {
    syncHiddenVariantState();
    if ($('.template-product .jsc-variant-details.jsc-hidden-variant').length) {
      setTimeout(function () {
        jscResetProductSlideInlineDisplay();
        var opt1AfterSync = $('.template-product input[data-index="option1"]:checked').first().val();
        if (opt1AfterSync != null && opt1AfterSync !== '') {
          setupVariantOption(opt1AfterSync);
        }
        jscRefreshBirthstoneVariantImages();
      }, 60);
    }
    $(document).off('change.jsc-hidden-variant-fallback', '.template-product input[data-single-option-selector]');
    $(document).on('change.jsc-hidden-variant-fallback', '.template-product input[data-single-option-selector]', function () {
      syncHiddenVariantState(this);
    });
  }, 1000);
}
//end: show or hide variant button

document.addEventListener('theme:variant:change', function (event) {
  var variant = event.detail && event.detail.variant;
  if (!variant || !variant.id) return;

  document.querySelectorAll('.jsc-pdp-bis.BIS_trigger').forEach(function (button) {
    button.setAttribute('data-variant-id', variant.id);
  });
});
